import { extractButtonBasic } from '../ui-modules/button-primary/extract-update';

import { extractContainerFuild } from './container-fuild';

export const extractDataAttributesFromHTML = {
  sectionBannerSlider(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      'list-item': [],
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'container-page': {
          result[key] = el.getAttribute('data-show-style') === 'true' ? true : false;
          break;
        }
        case 'list-item': {
          const elItems = el.querySelectorAll('[data-attribute="item"]');
          elItems.forEach(elItem => {
            const elImageBanner = elItem.querySelector('[data-attribute="image-banner"]');
            const elTextBanner = elItem.querySelector('[data-attribute="text-banner"]');
            const elButtonBannerWrap = elItem.querySelector('[data-attribute="button-banner"]');
            const elButtonLink = elItem.querySelector('[data-attribute="button-link"]');
            const elOverlaySlide = elItem.querySelector('[data-attribute="overlay-slide"]');

            const imageBanner = elImageBanner ? elImageBanner.getAttribute('src') : '';
            const textBanner = {
              text: elTextBanner ? elTextBanner.innerHTML.trim() : '',
              showText: elTextBanner ? elTextBanner.getAttribute('data-show-text') === 'true' : false,
            };
            const buttonBanner = {
              text: elButtonLink ? elButtonLink.textContent.trim() : '',
              showBtn: elButtonBannerWrap ? elButtonBannerWrap.getAttribute('data-show-button') === 'true' : false,
              link: elButtonLink ? elButtonLink.getAttribute('href') : '',
              background: elButtonLink ? elButtonLink.getAttribute('data-background') : '',
              color: elButtonLink ? elButtonLink.getAttribute('data-color') : '',
            };

            const overlaySlide = {
              showOverlay: elOverlaySlide ? elOverlaySlide.getAttribute('data-show-overlay') === 'true' : false,
              opacity: elOverlaySlide ? elOverlaySlide.getAttribute('data-opacity') : '',
            };

            const itemBanner = {
              image: imageBanner,
              textBanner: textBanner,
              button: buttonBanner,
              overlay: overlaySlide,
            };
            result['list-item'].push(itemBanner);
          });

          break;
        }
      }
    });
    return result;
  },
  sectionBannerHsia(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Banner Hsia Section',
      styleSection: {
        topPadding: false,
        bottomPadding: false,
        background: '#FFFFFF',
        textColor: '#000000',
      },
      containerPage: {
        enableStyle: false,
        background: '#FFFFFF',
      },
      'list-item': [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Banner Hsia Section';
    }

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result.styleSection.topPadding = cardContainer.getAttribute('data-top-padding') === 'true';
      result.styleSection.bottomPadding = cardContainer.getAttribute('data-bottom-padding') === 'true';
      result.styleSection.background = cardContainer.getAttribute('data-background') || '#FFFFFF';
      result.styleSection.textColor = cardContainer.getAttribute('data-text-color') || '#000000';
    }

    const containerPage = doc.querySelector('[data-attribute="container-page"]');
    if (containerPage) {
      const enableStyleAttr =
        containerPage.getAttribute('data-enable-style') ?? containerPage.getAttribute('data-show-style');
      result.containerPage.enableStyle = enableStyleAttr === 'true';
      result.containerPage.background = containerPage.getAttribute('data-background-container') || '#FFFFFF';
    }

    const listItem = doc.querySelector('[data-attribute="list-item"]');
    const itemEls = listItem ? listItem.querySelectorAll('[data-attribute="item"]') : [];
    itemEls.forEach(elItem => {
      const imageBanner = elItem.querySelector('[data-attribute="image-banner"]');
      const imageBannerMobile = elItem.querySelector('[data-attribute="image-banner-mobile"]');
      const linkItem = elItem.querySelector('[data-attribute="link-item"]') || elItem.querySelector('.wrap-item[href]');
      const useMobile = linkItem ? linkItem.getAttribute('data-use-mobile') === 'true' : false;
      result['list-item'].push({
        image: imageBanner ? imageBanner.getAttribute('src') || '' : '',
        imageMobile: imageBannerMobile ? imageBannerMobile.getAttribute('src') || '' : '',
        link: linkItem ? linkItem.getAttribute('href') || '#' : '#',
        useMobile: useMobile,
      });
    });

    if (!result['list-item'].length) {
      result['list-item'].push({
        image: '',
        imageMobile: '',
        link: '#',
        useMobile: false,
      });
    }

    return result;
  },
  sectionCardSona(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      'card-container': '',
      'card-item-image': '',
      'card-item-content': '',
      'card-image': '',
      'card-title': '',
      'card-description': '',
      'style-center-y': true,
      'text-color': '#000000',
      'button-text-color': '#ffffff',
      buttonCard: {
        show: true,
        background: '#000000',
        color: '#FFFFFF',
        radius: 0,
        text: '',
        link: '',
      },
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    // Extract container colors
    const containerEl = doc.querySelector('[data-attribute="card-container"]');
    if (containerEl) {
      result['text-color'] = containerEl.getAttribute('data-text-color') || containerEl.style.color || '#000000';
      result['button-text-color'] = containerEl.getAttribute('data-button-text-color') || '#ffffff';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          result[key] = el.getAttribute('data-background');
          break;
        }
        case 'card-item-image': {
          result[key] = el.getAttribute('data-order');
          break;
        }
        case 'card-item-content': {
          result[key] = el.getAttribute('data-order');
          const styleCenterY = el.getAttribute('data-style-center-y') === 'true' ? true : false;
          result['style-center-y'] = styleCenterY;
          break;
        }
        case 'card-image': {
          const img = el.getAttribute('src');
          result[key] = img ? img : '';
          break;
        }
        case 'card-title': {
          result[key] = el.innerHTML.trim();
          break;
        }
        case 'card-description': {
          result[key] = el.innerHTML.trim();
          break;
        }
        case 'card-btn-row': {
          const showBtn = el.getAttribute('data-show-btn') === 'true' ? true : false;
          const elBtn = el.querySelector('[data-attribute="card-btn"]');
          const background = elBtn ? elBtn.getAttribute('data-background') : '';
          const color = elBtn ? elBtn.getAttribute('data-color') : '';
          const radius = elBtn ? elBtn.getAttribute('data-radius') : '';
          const text = elBtn ? elBtn.textContent.trim() : '';
          const link = elBtn ? elBtn.getAttribute('href') : '';
          result.buttonCard = {
            show: showBtn,
            background: background,
            color: color,
            radius: radius,
            text: text,
            link: link,
          };
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionCustomizeCard(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {};

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          const background = el.getAttribute('data-background');
          result[key] = background ? background : '#ffffff';
          const paginationActiveColor = el.getAttribute('data-pagination-active-color');
          result['pagination-active-color'] = paginationActiveColor ? paginationActiveColor : '#000000';
          const paginationInactiveColor = el.getAttribute('data-pagination-inactive-color');
          result['pagination-inactive-color'] = paginationInactiveColor ? paginationInactiveColor : '#cccccc';
          break;
        }
        case 'card-item-content': {
          const order = el.getAttribute('data-order');
          result[key] = order ? Number(order) : 1;
          const styleCenterY = el.getAttribute('data-style-center-y');
          result['style-center-y'] = styleCenterY ? styleCenterY === 'true' : false;
          break;
        }
        case 'card-item-image': {
          const order = el.getAttribute('data-order');
          result[key] = order ? Number(order) : 2;
          break;
        }
        case 'card-btn-row': {
          const showBtn = el.getAttribute('data-show-btn');
          result[key] = showBtn ? showBtn === 'true' : false;
          break;
        }
        case 'card-rated-row': {
          const showRating = el.getAttribute('data-show-rating');
          result[key] = showRating ? showRating === 'true' : false;
          break;
        }
        case 'card-btn': {
          result[key] = {
            text: el.textContent.trim(),
            url: el.getAttribute('href') || '',
            background: el.getAttribute('data-background') || el.style.backgroundColor || '#2d3436',
            color: el.getAttribute('data-color') || el.style.color || '#ffffff',
          };
          break;
        }
        case 'card-image': {
          result[key] = el.getAttribute('src') || '';
          break;
        }
        case 'sub-btn': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'rating-stars': {
          const value = el.getAttribute('data-value');
          result[key] = value ? Number(value) : 5;
          break;
        }
        case 'rating-text': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'container-page': {
          result[key] = {};
          const showStyle = el.getAttribute('data-show-style');
          result[key]['show-style'] = showStyle ? showStyle === 'true' : false;
          const background = el.getAttribute('data-background');
          result[key]['background'] = background ? background : '#ffffff';
          break;
        }
        case 'card-title': {
          result[key] = el.innerHTML.trim();
          break;
        }
        case 'card-description': {
          result[key] = el.innerHTML.trim();
          const textColor = el.getAttribute('data-text-color');
          result['text-color'] = textColor ? textColor : '';
          break;
        }
        case 'card-survay': {
          const showSurvay = el.getAttribute('data-show-survay');
          result[key] = showSurvay ? showSurvay === 'true' : false;
          const elItems = el.querySelectorAll('[data-attribute="item-survay"]');
          const itemsSurvay = Array.from(elItems).map(item => {
            const percent = +item.querySelector('[data-attribute="percent-survay"]')?.textContent.trim() || 0;
            const description = item.querySelector('[data-attribute="description-survay"]')?.textContent.trim() || '';
            return {
              percent,
              description,
            };
          });
          result['items-survay'] = itemsSurvay;
          break;
        }
        default:
          break;
      }
    });

    return result;
  },
  sectionCardCigar(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {};

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          const background = el.getAttribute('data-background');
          result[key] = background ? background : '#ffffff';
          const paginationActiveColor = el.getAttribute('data-pagination-active-color');
          result['pagination-active-color'] = paginationActiveColor ? paginationActiveColor : '#000000';
          const paginationInactiveColor = el.getAttribute('data-pagination-inactive-color');
          result['pagination-inactive-color'] = paginationInactiveColor ? paginationInactiveColor : '#cccccc';
          break;
        }
        case 'card-item-content': {
          const order = el.getAttribute('data-order');
          result[key] = order ? Number(order) : 1;
          const styleCenterY = el.getAttribute('data-style-center-y');
          result['style-center-y'] = styleCenterY ? styleCenterY === 'true' : false;
          break;
        }
        case 'card-item-image': {
          const order = el.getAttribute('data-order');
          result[key] = order ? Number(order) : 2;
          break;
        }
        case 'card-btn-row': {
          const showBtn = el.getAttribute('data-show-btn');
          result[key] = showBtn ? showBtn === 'true' : false;
          break;
        }
        case 'card-rated-row': {
          const showRating = el.getAttribute('data-show-rating');
          result[key] = showRating ? showRating === 'true' : false;
          break;
        }
        case 'card-btn': {
          result[key] = {
            text: el.textContent.trim(),
            url: el.getAttribute('href') || '',
            background: el.getAttribute('data-background') || el.style.backgroundColor || '#2d3436',
            color: el.getAttribute('data-color') || el.style.color || '#ffffff',
            radius: el.getAttribute('data-radius') || el.style.borderRadius || '0',
          };
          break;
        }
        // case 'card-content': {
        //   result[key] = el.innerHTML.trim()
        //   break
        // }
        case 'wrap-img': {
          result['wrap-img-radius'] = el.getAttribute('data-radius') || el.style.borderRadius || '0';
          break;
        }
        case 'card-image': {
          result[key] = el.getAttribute('src') || '';
          break;
        }
        case 'sub-btn': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'rating-stars': {
          const value = el.getAttribute('data-value');
          result[key] = value ? Number(value) : 5;
          break;
        }
        case 'rating-text': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'container-page': {
          result[key] = {};
          const showStyle = el.getAttribute('data-show-style');
          result[key]['show-style'] = showStyle ? showStyle === 'true' : false;
          const background = el.getAttribute('data-background');
          result[key]['background'] = background ? background : '#ffffff';
          break;
        }
        case 'card-title': {
          result[key] = el.innerHTML.trim();
          break;
        }
        case 'card-description': {
          result[key] = el.innerHTML.trim();
          const textColor = el.getAttribute('data-text-color');
          result['text-color'] = textColor ? textColor : '';
          break;
        }
        case 'card-survay': {
          const showSurvay = el.getAttribute('data-show-survay');
          result[key] = showSurvay ? showSurvay === 'true' : false;
          const elItems = el.querySelectorAll('[data-attribute="item-survay"]');
          const itemsSurvay = Array.from(elItems).map(item => {
            const percent = +item.querySelector('[data-attribute="percent-survay"]')?.textContent.trim() || 0;
            const description = item.querySelector('[data-attribute="description-survay"]')?.textContent.trim() || '';
            return {
              percent,
              description,
            };
          });
          result['items-survay'] = itemsSurvay;
          break;
        }
        default:
          break;
      }
    });

    return result;
  },
  sectionCardKynorelle(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Kynorelle Section',
      'card-container': '#FFFFFF',
      'text-color': '#000000',
      'top-padding': false,
      'bottom-padding': false,
      'container-page': {
        'show-style': false,
        background: '#FFFFFF',
      },
      'card-item-content': 1,
      'card-item-image': 2,
      'style-center-y': false,
      'card-title': '',
      'card-description': '',
      'highlight-text': {
        show: true,
        content: '',
      },
      'card-survay': true,
      'color-percent-survay': '#606F99',
      'items-survay': [],
      button: {
        show: true,
        text: '',
        link: '#',
        background: '#F35C5C',
        color: '#ffffff',
        radius: '0',
      },
      'sub-btn': '',
      media: {
        'show-image': true,
        image: '',
        'show-video': true,
        video: '',
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title || result.title;
    }

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result['card-container'] = cardContainer.getAttribute('data-background') || '#FFFFFF';
      result['text-color'] = cardContainer.getAttribute('data-color') || '#000000';
      result['top-padding'] = cardContainer.getAttribute('data-top-padding') === 'true';
      result['bottom-padding'] = cardContainer.getAttribute('data-bottom-padding') === 'true';
    }

    const containerPage = doc.querySelector('[data-attribute="container-page"]');
    if (containerPage) {
      result['container-page'] = {
        'show-style': containerPage.getAttribute('data-show-style') === 'true',
        background: containerPage.getAttribute('data-background') || '#FFFFFF',
      };
    }

    const cardItemContent = doc.querySelector('[data-attribute="card-item-content"]');
    if (cardItemContent) {
      result['card-item-content'] = Number(cardItemContent.getAttribute('data-order') || 1);
      result['style-center-y'] = cardItemContent.getAttribute('data-style-center-y') === 'true';
    }

    const cardItemImage = doc.querySelector('[data-attribute="card-item-image"]');
    if (cardItemImage) {
      result['card-item-image'] = Number(cardItemImage.getAttribute('data-order') || 2);
    }

    const contentCard = doc.querySelector('[data-attribute="content-card"]');
    if (contentCard) {
      result['card-title'] = contentCard.innerHTML.trim();
    }

    const highlightText = doc.querySelector('[data-attribute="highlight-text"]');
    if (highlightText) {
      result['highlight-text'] = {
        show: highlightText.getAttribute('data-show') === 'true',
        content: highlightText.textContent.trim(),
      };
    }

    const cardSurvay = doc.querySelector('[data-attribute="card-survay"]');
    if (cardSurvay) {
      result['card-survay'] = cardSurvay.getAttribute('data-show-survay') === 'true';
      result['color-percent-survay'] = cardSurvay.getAttribute('data-color-percent') || '#606F99';
      const items = cardSurvay.querySelectorAll('[data-attribute="item-survay"]');
      result['items-survay'] = Array.from(items).map(item => {
        const percentEl = item.querySelector('[data-attribute="percent-survay"]');
        const percentRaw = percentEl?.getAttribute('data-value') || percentEl?.textContent || 0;
        const percent = Number.isFinite(Number(percentRaw)) ? Number(percentRaw) : 0;
        const description = item.querySelector('[data-attribute="description-survay"]')?.innerHTML.trim() || '';
        return {
          percent,
          description,
        };
      });
    }

    if (!result['items-survay'].length) {
      result['items-survay'] = [{ percent: 0, description: '' }];
    }

    const buttonRow = doc.querySelector('[data-attribute="card-btn-row"]');
    const buttonEl = doc.querySelector('[data-attribute="card-btn"]');
    if (buttonRow || buttonEl) {
      const buttonText = buttonEl?.querySelector('[data-attribute="btn-text"]');
      result.button = {
        show: buttonRow ? buttonRow.getAttribute('data-show-btn') === 'true' : true,
        text: buttonText ? buttonText.textContent.trim() : '',
        link: buttonEl?.getAttribute('href') || '#',
        background: buttonEl?.getAttribute('data-background') || '#F35C5C',
        color: buttonEl?.getAttribute('data-color') || '#ffffff',
        radius: buttonEl?.getAttribute('data-radius') || '0',
      };
    }

    const subBtn = doc.querySelector('[data-attribute="sub-btn"]');
    if (subBtn) {
      result['sub-btn'] = subBtn.textContent.trim();
    }

    const wrapImage = doc.querySelector('[data-attribute="wrap-image"]');
    if (wrapImage) {
      result.media['show-image'] = wrapImage.getAttribute('data-show-image') === 'true';
      result.media.image = wrapImage.querySelector('[data-attribute="image"]')?.getAttribute('src') || '';
    }

    const wrapVideo = doc.querySelector('[data-attribute="wrap-video"]');
    if (wrapVideo) {
      result.media['show-video'] = wrapVideo.getAttribute('data-show-video') === 'true';
      result.media.video = wrapVideo.querySelector('[data-attribute="card-video"]')?.getAttribute('src') || '';
    }

    return result;
  },
  sectionCardHsiaCategory(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Hsia Category Section',
      'card-title': '',
      'show-card-title': true,
      styleSection: {
        topPadding: true,
        bottomPadding: true,
        background: '#FFFFFF',
        textColor: '#000000',
      },
      containerPage: {
        enableStyle: false,
        background: '#FFFFFF',
      },
      colPerView: 8,
      categories: [
        {
          title: 'Minimizer Bra',
          image: '',
          link: '#',
        },
      ],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.title = sectionEl.getAttribute('data-title') || result.title;
    }

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result.styleSection.topPadding = cardContainer.getAttribute('data-top-padding') === 'true';
      result.styleSection.bottomPadding = cardContainer.getAttribute('data-bottom-padding') === 'true';
      result.styleSection.background = cardContainer.getAttribute('data-background') || '#FFFFFF';
      result.styleSection.textColor = cardContainer.getAttribute('data-text-color') || '#000000';
    }

    const containerPage = doc.querySelector('[data-attribute="container-page"]');
    if (containerPage) {
      result.containerPage.enableStyle = containerPage.getAttribute('data-enable-style') === 'true';
      result.containerPage.background = containerPage.getAttribute('data-background-container') || '#FFFFFF';
    }

    const cardTitle = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitle) {
      result['card-title'] = cardTitle.innerHTML.trim();
      result['show-card-title'] = cardTitle.getAttribute('data-show') === 'true';
    }

    const listItem = doc.querySelector('[data-attribute="list-item"]');
    if (listItem) {
      const colPerView = Number(listItem.getAttribute('data-colperview'));
      if (Number.isFinite(colPerView) && colPerView > 0) {
        result.colPerView = colPerView;
      }
    }

    const categories = Array.from(doc.querySelectorAll('[data-attribute="item-category"]')).map(item => {
      const image = item.querySelector('[data-attribute="image-category"]')?.getAttribute('src') || '';
      const title = item.querySelector('[data-attribute="title-category"]')?.textContent?.trim() || '';
      const link = item.getAttribute('href') || '#';
      return {
        title,
        image,
        link,
      };
    });

    if (categories.length) {
      result.categories = categories;
    }

    return result;
  },
  sectionCardHsiaGrid(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Hsia Grid Section',
      'card-title': '',
      'show-card-title': true,
      styleSection: {
        topPadding: true,
        bottomPadding: true,
        background: '#FFFFFF',
        textColor: '#000000',
      },
      containerPage: {
        enableStyle: false,
        background: '#FFFFFF',
      },
      items: [
        {
          image: 'https://www.hsialife.com/cdn/shop/files/hsia-minimizer-bra-on-model.jpg?v=1778124445&width=790',
          link: '#',
        },
      ],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.title = sectionEl.getAttribute('data-title') || result.title;
    }

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result.styleSection.topPadding = cardContainer.getAttribute('data-top-padding') === 'true';
      result.styleSection.bottomPadding = cardContainer.getAttribute('data-bottom-padding') === 'true';
      result.styleSection.background = cardContainer.getAttribute('data-background') || '#FFFFFF';
      result.styleSection.textColor = cardContainer.getAttribute('data-text-color') || '#000000';
    }

    const containerPage = doc.querySelector('[data-attribute="container-page"]');
    if (containerPage) {
      result.containerPage.enableStyle = containerPage.getAttribute('data-enable-style') === 'true';
      result.containerPage.background = containerPage.getAttribute('data-background-container') || '#FFFFFF';
    }

    const cardTitle = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitle) {
      result['card-title'] = cardTitle.innerHTML.trim();
      result['show-card-title'] = cardTitle.getAttribute('data-show') === 'true';
    }

    const items = Array.from(doc.querySelectorAll('[data-attribute="item"]')).map(item => {
      const image = item.querySelector('[data-attribute="image-item"]')?.getAttribute('src') || '';
      const link = item.getAttribute('href') || '#';
      return {
        image,
        link,
      };
    });

    if (items.length) {
      result.items = items;
    }

    return result;
  },
  sectionCardReviewHsiaGrid(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Review Hsia Grid Section',
      'card-title':
        '<h2>Over 200K+ Happy Customers</h2><p>Best-of-the-best minimizer bra wardrobe staples, A perfect blend of comfort, support, and a flattering sihouette.</p>',
      'show-card-title': true,
      styleSection: {
        topPadding: true,
        bottomPadding: true,
        background: '#FFFFFF',
        textColor: '#000000',
      },
      containerPage: {
        enableStyle: false,
        background: '#FFFFFF',
      },
      'show-list-image-review': true,
      images: [],
      'show-list-review-text': true,
      'color-star': '#b75d3e',
      'bg-item-review': '#f7f7f7',
      reviews: [
        {
          link: '#',
          stars: 5,
          content:
            "<h3>Perfect Fit</h3><p>This is honestly the best bra I've ever worn. l can't even feel that I'm wearing it.It definitely minimizes-I did the jump and shake test, and the girls fully stayed inplace.</p>",
          'show-button': true,
          'button-text': 'SHOP THIS ITEM',
        },
      ],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.title = sectionEl.getAttribute('data-title') || result.title;
    }

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result.styleSection.topPadding = cardContainer.getAttribute('data-top-padding') === 'true';
      result.styleSection.bottomPadding = cardContainer.getAttribute('data-bottom-padding') === 'true';
      result.styleSection.background = cardContainer.getAttribute('data-background') || '#FFFFFF';
      result.styleSection.textColor = cardContainer.getAttribute('data-text-color') || '#000000';
    }

    const containerPage = doc.querySelector('[data-attribute="container-page"]');
    if (containerPage) {
      result.containerPage.enableStyle = containerPage.getAttribute('data-enable-style') === 'true';
      result.containerPage.background = containerPage.getAttribute('data-background-container') || '#FFFFFF';
    }

    const cardTitle = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitle) {
      result['card-title'] = cardTitle.innerHTML.trim();
      result['show-card-title'] = cardTitle.getAttribute('data-show') === 'true';
    }

    const listImageReview = doc.querySelector('[data-attribute="list-image-review"]');
    if (listImageReview) {
      result['show-list-image-review'] = listImageReview.getAttribute('data-show') === 'true';
    }

    const images = Array.from(doc.querySelectorAll('[data-attribute="image-item-review"]'))
      .map(item => item.getAttribute('src') || '')
      .filter(Boolean);
    if (images.length) {
      result.images = images;
    }

    const listReviewText = doc.querySelector('[data-attribute="list-review-text"]');
    if (listReviewText) {
      result['show-list-review-text'] = listReviewText.getAttribute('data-show') === 'true';
      result['color-star'] = listReviewText.getAttribute('data-color-star') || result['color-star'];
      result['bg-item-review'] = listReviewText.getAttribute('data-bg-item-review') || result['bg-item-review'];
    }

    const reviews = Array.from(doc.querySelectorAll('[data-attribute="item-review-text"]')).map(item => {
      const starEl = item.querySelector('[data-attribute="star-item-review"]');
      const contentEl = item.querySelector('[data-attribute="text-item-review"]');
      const buttonEl = item.querySelector('[data-attribute="btn-item-review"]');
      const buttonTextEl = item.querySelector('[data-attribute="btn-item-review-text"]');
      const starValue = Number(starEl?.getAttribute('data-value') || 5);
      return {
        link: item.getAttribute('href') || '#',
        stars: Number.isFinite(starValue) ? Math.max(0, Math.min(5, starValue)) : 5,
        content: contentEl?.innerHTML.trim() || '',
        'show-button': buttonEl ? buttonEl.getAttribute('data-show') === 'true' : true,
        'button-text': buttonTextEl?.textContent?.trim() || '',
      };
    });

    if (reviews.length) {
      result.reviews = reviews;
    }

    return result;
  },
  sectionCardHsiaTags(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Hsia Tags Section',
      styleSection: {
        topPadding: false,
        bottomPadding: false,
        background: '#FFFFFF',
        textColor: '#000000',
      },
      containerPage: {
        enableStyle: false,
        background: '#FFFFFF',
      },
      'bg-card': '#f5f1ee',
      'card-left-order': 1,
      'card-right-order': 2,
      'card-title': '',
      tags: [],
      'color-tag-item': '#ffffff',
      'bg-tag-item': '#000000',
      'color-hover-tag-item': '#000000',
      'bg-hover-tag-item': '#ffffff',
      media: {
        type: 'video',
        video: '',
        image: '',
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.title = sectionEl.getAttribute('data-title') || result.title;
    }
    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result.styleSection['topPadding'] = cardContainer.getAttribute('data-top-padding') === 'true';
      result.styleSection['bottomPadding'] = cardContainer.getAttribute('data-bottom-padding') === 'true';
      result.styleSection['background'] = cardContainer.getAttribute('data-background') || '#FFFFFF';
      result.styleSection['textColor'] = cardContainer.getAttribute('data-text-color') || '#000000';
    }

    const containerPage = doc.querySelector('[data-attribute="container-page"]');
    if (containerPage) {
      result.containerPage['enableStyle'] = containerPage.getAttribute('data-enable-style') === 'true';
      result.containerPage['background'] = containerPage.getAttribute('data-background-container') || '#FFFFFF';
    }

    const wrapCard = doc.querySelector('[data-attribute="wrap-card"]');
    if (wrapCard) {
      result['bg-card'] = wrapCard.getAttribute('data-bg-card') || result['bg-card'];
    }

    const cardLeft = doc.querySelector('[data-attribute="card-left"]');
    if (cardLeft) {
      result['card-left-order'] = Number(cardLeft.getAttribute('data-order') || 1);
    }

    const cardRight = doc.querySelector('[data-attribute="card-right"]');
    if (cardRight) {
      result['card-right-order'] = Number(cardRight.getAttribute('data-order') || 2);
    }

    const titleEl = doc.querySelector('[data-attribute="card-title"]');
    if (titleEl) {
      result['card-title'] = titleEl.innerHTML.trim();
    }

    const listTags = doc.querySelector('[data-attribute="list-tags"]');
    if (listTags) {
      result['color-tag-item'] = listTags.getAttribute('data-color-tag-item') || result['color-tag-item'];
      result['bg-tag-item'] = listTags.getAttribute('data-bg-tag-item') || result['bg-tag-item'];
      result['color-hover-tag-item'] =
        listTags.getAttribute('data-color-hover-tag-item') || result['color-hover-tag-item'];
      result['bg-hover-tag-item'] = listTags.getAttribute('data-bg-hover-tag-item') || result['bg-hover-tag-item'];
    }

    const tagItems =
      Array.from(doc.querySelectorAll('[data-attribute="tag-item"]'))?.map(item => {
        return {
          text: item.textContent.trim(),
          link: item.getAttribute('href') || '#',
        };
      }) || [];
    if (tagItems.length) {
      result.tags = tagItems;
    }

    const wrapVideo = doc.querySelector('[data-attribute="video-card"]');
    if (wrapVideo) {
      const showVideo = wrapVideo.getAttribute('data-show-video') === 'true';
      result.media.video = wrapVideo.querySelector('[data-attribute="video-item"]')?.getAttribute('src') || '';
      if (showVideo) result.media.type = 'video';
    }

    const wrapImage = doc.querySelector('[data-attribute="image-card"]');
    if (wrapImage) {
      const showImage = wrapImage.getAttribute('data-show-image') === 'true';
      result.media.image = wrapImage.querySelector('[data-attribute="image-item"]')?.getAttribute('src') || '';
      if (showImage) result.media.type = 'image';
    }

    return result;
  },
  sectionCardFaqKynorelle(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card FAQ Kynorelle Section',
      'card-container': '#FFFFFF',
      'text-color': '#000000',
      'top-padding': false,
      'bottom-padding': false,
      'container-page': {
        'show-style': false,
        background: '#FFFFFF',
      },
      'card-item-content': 1,
      'card-item-image': 2,
      'style-center-y': false,
      'content-title': {
        show: true,
        heading: '',
      },
      accordions: {
        show: true,
        items: [{ title: '', text: '' }],
      },
      button: {
        show: true,
        text: 'SHOP NOW',
        link: '#',
        background: '#003568',
        color: '#ffffff',
        radius: '4',
      },
      media: {
        'show-image': true,
        image: '',
        'show-video': false,
        video: '',
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title || result.title;
    }

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result['card-container'] = cardContainer.getAttribute('data-background') || result['card-container'];
      result['text-color'] = cardContainer.getAttribute('data-color') || result['text-color'];
      result['top-padding'] = cardContainer.getAttribute('data-top-padding') === 'true';
      result['bottom-padding'] = cardContainer.getAttribute('data-bottom-padding') === 'true';
    }

    const containerPage = doc.querySelector('[data-attribute="container-page"]');
    if (containerPage) {
      result['container-page'] = {
        'show-style': containerPage.getAttribute('data-show-style') === 'true',
        background: containerPage.getAttribute('data-background') || '#FFFFFF',
      };
    }

    const cardItemContent = doc.querySelector('[data-attribute="card-item-content"]');
    if (cardItemContent) {
      result['card-item-content'] = Number(cardItemContent.getAttribute('data-order') || 1);
      result['style-center-y'] = cardItemContent.getAttribute('data-style-center-y') === 'true';
    }

    const cardItemImage = doc.querySelector('[data-attribute="card-item-image"]');
    if (cardItemImage) {
      result['card-item-image'] = Number(cardItemImage.getAttribute('data-order') || 2);
    }

    const contentTitle = doc.querySelector('[data-attribute="content-title"]');
    if (contentTitle) {
      const showTitle = contentTitle.getAttribute('data-show-title') !== 'false';
      const headingHtml = contentTitle.innerHTML.trim();
      result['content-title'] = {
        show: showTitle,
        heading: showTitle ? headingHtml : '',
      };
    }

    const accordionsWrap = doc.querySelector('[data-attribute="card-accordions"]');
    if (accordionsWrap) {
      const items = Array.from(accordionsWrap.querySelectorAll('[data-attribute="card-accordion"]')).map(item => {
        const titleEl = item.querySelector('[data-attribute="accordion-title-text"]');
        const textEl = item.querySelector('[data-attribute="accordion-text"]');
        return {
          title: titleEl ? titleEl.textContent.trim() : '',
          text: textEl ? textEl.innerHTML.trim() : '',
        };
      });

      result.accordions = {
        show: accordionsWrap.getAttribute('data-show-accordion') !== 'false',
        items: items.length ? items : [{ title: '', text: '' }],
      };
    }

    const buttonRow = doc.querySelector('[data-attribute="button"]');
    const buttonEl = doc.querySelector('[data-attribute="card-btn"]');
    if (buttonRow || buttonEl) {
      const buttonText = buttonEl?.querySelector('[data-attribute="btn-text"]');
      result.button = {
        show: buttonRow ? buttonRow.getAttribute('data-show-button') !== 'false' : true,
        text: buttonText ? buttonText.textContent.trim() : 'SHOP NOW',
        link: buttonEl?.getAttribute('href') || '#',
        background: buttonEl?.getAttribute('data-background') || '#003568',
        color: buttonEl?.getAttribute('data-color') || '#ffffff',
        radius: buttonEl?.getAttribute('data-radius') || '4',
      };
    }

    const wrapImage = doc.querySelector('[data-attribute="wrap-image"]');
    if (wrapImage) {
      result.media['show-image'] = wrapImage.getAttribute('data-show-image') !== 'false';
      result.media.image = wrapImage.querySelector('[data-attribute="image"]')?.getAttribute('src') || '';
    }

    const wrapVideo = doc.querySelector('[data-attribute="wrap-video"]');
    if (wrapVideo) {
      result.media['show-video'] = wrapVideo.getAttribute('data-show-video') === 'true';
      result.media.video = wrapVideo.querySelector('[data-attribute="card-video"]')?.getAttribute('src') || '';
    }

    return result;
  },
  sectionSliderReviewKynorelle(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Slider Review Kynorelle Section',
      'card-container': '#FFFFFF',
      'text-color': '#003568',
      'top-padding': true,
      'bottom-padding': true,
      'container-page': {
        'show-style': false,
        background: '#FFFFFF',
      },
      'content-title': {
        show: true,
        heading: '',
      },
      'title-card': {
        show: true,
        content: '',
      },
      'col-per-view': 4,
      reviews: [],
      button: {
        show: true,
        text: 'SHOP NOW',
        link: '#',
        background: '#003568',
        color: '#ffffff',
        radius: '4',
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.title = sectionEl.getAttribute('data-title') || result.title;
    }

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result['card-container'] = cardContainer.getAttribute('data-background') || result['card-container'];
      result['text-color'] = cardContainer.getAttribute('data-color') || result['text-color'];
      result['top-padding'] = cardContainer.getAttribute('data-top-padding') === 'true';
      result['bottom-padding'] = cardContainer.getAttribute('data-bottom-padding') === 'true';
    }

    const containerPage = doc.querySelector('[data-attribute="container-page"]');
    if (containerPage) {
      result['container-page'] = {
        'show-style': containerPage.getAttribute('data-show-style') === 'true',
        background: containerPage.getAttribute('data-background') || '#FFFFFF',
      };
    }

    const contentTitle = doc.querySelector('[data-attribute="content-title"]');
    if (contentTitle) {
      const showTitle = contentTitle.getAttribute('data-show-title') !== 'false';
      result['content-title'] = {
        show: showTitle,
        heading: showTitle ? contentTitle.innerHTML.trim() : '',
      };
    }

    const titleCard = doc.querySelector('[data-attribute="title-card"]');
    if (titleCard) {
      const showTitleCard = titleCard.getAttribute('data-show') !== 'false';
      result['title-card'] = {
        show: showTitleCard,
        content: showTitleCard ? titleCard.innerHTML.trim() : '',
      };
    }

    const bodyReview = doc.querySelector('[data-attribute="body-review"]');
    if (bodyReview) {
      result['col-per-view'] = Number(bodyReview.getAttribute('data-col-per-view') || 4);
    }

    result.reviews = Array.from(doc.querySelectorAll('[data-attribute="item-review"]')).map(item => {
      const imageEl = item.querySelector('[data-attribute="review-image"]');
      const starsEl = item.querySelector('[data-attribute="wrap-stars"]');
      const contentEl = item.querySelector('[data-attribute="review-content"]');
      const nameEl = item.querySelector('[data-attribute="review-name"]');

      return {
        image: imageEl?.getAttribute('src') || '',
        stars: Number(starsEl?.getAttribute('data-value') || 5),
        content: contentEl?.innerHTML.trim() || '<h3>Review title</h3><p>Review text</p>',
        name: nameEl?.textContent.trim() || '',
      };
    });

    if (!result.reviews.length) {
      result.reviews.push({
        image: '',
        stars: 5,
        content: '<h3>Review title</h3><p>Review text</p>',
        name: 'Customer',
      });
    }

    const buttonRow = doc.querySelector('[data-attribute="button"]');
    const buttonEl = doc.querySelector('[data-attribute="card-btn"]');
    if (buttonRow || buttonEl) {
      const buttonText = buttonEl?.querySelector('[data-attribute="btn-text"]');
      result.button = {
        show: buttonRow ? buttonRow.getAttribute('data-show-button') !== 'false' : true,
        text: buttonText?.textContent.trim() || 'SHOP NOW',
        link: buttonEl?.getAttribute('href') || '#',
        background: buttonEl?.getAttribute('data-background') || '#003568',
        color: buttonEl?.getAttribute('data-color') || '#ffffff',
        radius: buttonEl?.getAttribute('data-radius') || '4',
      };
    }

    return result;
  },
  sectionCardVideo(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {};

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          const background = el.getAttribute('data-background');
          result[key] = background ? background : '#ffffff';
          const paginationActiveColor = el.getAttribute('data-pagination-active-color');
          result['pagination-active-color'] = paginationActiveColor ? paginationActiveColor : '#000000';
          const paginationInactiveColor = el.getAttribute('data-pagination-inactive-color');
          result['pagination-inactive-color'] = paginationInactiveColor ? paginationInactiveColor : '#cccccc';
          break;
        }
        case 'card-item-content': {
          const order = el.getAttribute('data-order');
          result[key] = order ? Number(order) : 1;
          const styleCenterY = el.getAttribute('data-style-center-y');
          result['style-center-y'] = styleCenterY ? styleCenterY === 'true' : false;
          break;
        }
        case 'card-item-image': {
          const order = el.getAttribute('data-order');
          result[key] = order ? Number(order) : 2;
          break;
        }
        case 'card-btn-row': {
          const showBtn = el.getAttribute('data-show-btn');
          result[key] = showBtn ? showBtn === 'true' : false;
          break;
        }
        case 'card-rated-row': {
          const showRating = el.getAttribute('data-show-rating');
          result[key] = showRating ? showRating === 'true' : false;
          break;
        }
        case 'card-btn': {
          result[key] = {
            text: el.textContent.trim(),
            url: el.getAttribute('href') || '',
            background: el.getAttribute('data-background') || el.style.backgroundColor || '#2d3436',
            color: el.getAttribute('data-color') || el.style.color || '#ffffff',
            radius: el.getAttribute('data-radius') || el.style.borderRadius || '0',
          };
          break;
        }
        // case 'card-content': {
        //   result[key] = el.innerHTML.trim()
        //   break
        // }
        case 'wrap-img': {
          result['wrap-img-radius'] = el.getAttribute('data-radius') || el.style.borderRadius || '0';
          break;
        }
        case 'card-video': {
          result[key] = el.getAttribute('src') || '';
          break;
        }
        case 'sub-btn': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'rating-stars': {
          const value = el.getAttribute('data-value');
          result[key] = value ? Number(value) : 5;
          break;
        }
        case 'rating-text': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'container-page': {
          result[key] = {};
          const showStyle = el.getAttribute('data-show-style');
          result[key]['show-style'] = showStyle ? showStyle === 'true' : false;
          const background = el.getAttribute('data-background');
          result[key]['background'] = background ? background : '#ffffff';
          break;
        }
        case 'card-title': {
          result[key] = el.innerHTML.trim();
          break;
        }
        case 'card-description': {
          result[key] = el.innerHTML.trim();
          const textColor = el.getAttribute('data-text-color');
          result['text-color'] = textColor ? textColor : '';
          break;
        }
        case 'card-survay': {
          const showSurvay = el.getAttribute('data-show-survay');
          result[key] = showSurvay ? showSurvay === 'true' : false;
          const elItems = el.querySelectorAll('[data-attribute="item-survay"]');
          const itemsSurvay = Array.from(elItems).map(item => {
            const percent = +item.querySelector('[data-attribute="percent-survay"]')?.textContent.trim() || 0;
            const description = item.querySelector('[data-attribute="description-survay"]')?.textContent.trim() || '';
            return {
              percent,
              description,
            };
          });
          result['items-survay'] = itemsSurvay;
          break;
        }
        default:
          break;
      }
    });

    return result;
  },
  sectionCardVideoSlider(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: '',
      'card-container': '',
      header: {
        show: false,
        content: '',
      },
      btnPlayVideo: {
        background: '#000000',
        color: '#FFFFFF',
      },
      listItem: [],
    };

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          const background = el.getAttribute('data-background');
          result[key] = background ? background : '#ffffff';
          break;
        }
        case 'card-header': {
          result.header.content = el.innerHTML.trim();
          result.header.show = el.getAttribute('data-show') === 'true' ? true : false;
          break;
        }
        case 'list-item': {
          const bgPlayVideo = el.getAttribute('data-bg-play-video');
          const colorPlayVideo = el.getAttribute('data-color-play-video');
          result.btnPlayVideo = {
            background: bgPlayVideo ? bgPlayVideo : '#000000',
            color: colorPlayVideo ? colorPlayVideo : '#FFFFFF',
          };
          el.querySelectorAll('[data-attribute="item"]').forEach(item => {
            result.listItem.push({
              video: item.querySelector('[data-attribute="card-video"]')?.getAttribute('src') || '',
            });
          });
          break;
        }
        default:
          break;
      }
    });

    return result;
  },
  sectionProductsSlider(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: '',
      containerBackground: '#ffffff',
      header: '',
      listItem: [],
      itemCommon: {
        background: '#f6f6f6',
        color: '#000000',
        radius: '10',
        saveBg: '#6293c1',
        saveColor: '#FFFFFF',
        btnBg: '#6293c1',
        btnColor: '#FFFFFF',
        btnRadius: '10',
        btnText: 'Show Now',
        link: '',
      },
    };

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          const background = el.getAttribute('data-background');
          result['containerBackground'] = background ? background : '#ffffff';
          break;
        }
        case 'section-header': {
          result['header'] = el.innerHTML.trim();
          break;
        }
        case 'list-item': {
          const elWrapItem = el.querySelector('[data-attribute="wrap-item"]');
          const background = elWrapItem ? elWrapItem.getAttribute('data-bg') : '#f6f6f6';
          const color = elWrapItem ? elWrapItem.getAttribute('data-color') : '#000000';
          const radius = elWrapItem ? elWrapItem.getAttribute('data-radius') : '10';

          const elSave = el.querySelector('[data-attribute="price-sale"]');
          const saveBg = elSave ? elSave.getAttribute('data-bg') : '#6293c1';
          const saveColor = elSave ? elSave.getAttribute('data-color') : '#FFFFFF';

          const elBtnViewMore = el.querySelector('[data-attribute="btn-view-more"]');
          const btnBg = elBtnViewMore ? elBtnViewMore.getAttribute('data-bg') : '#6293c1';
          const btnColor = elBtnViewMore ? elBtnViewMore.getAttribute('data-color') : '#FFFFFF';
          const btnRadius = elBtnViewMore ? elBtnViewMore.getAttribute('data-radius') : '10';
          const btnText = elBtnViewMore ? elBtnViewMore.innerHTML.trim() : 'Show Now';

          result['itemCommon'] = {
            background: background,
            color: color,
            radius: radius,
            saveBg: saveBg,
            saveColor: saveColor,
            btnBg: btnBg,
            btnColor: btnColor,
            btnRadius: btnRadius,
            btnText: btnText,
          };

          el.querySelectorAll('[data-attribute="item"]').forEach(item => {
            const elLink = item.querySelector('[data-attribute="wrap-item"]');
            const link = elLink ? elLink.getAttribute('href') : '';

            const elImg = item.querySelector('[data-attribute="img-item"]');
            const image = elImg ? elImg.getAttribute('src') : '';

            const elWrapRated = item.querySelector('[data-attribute="wrap-rated"]');
            const showRating = elWrapRated ? elWrapRated.getAttribute('data-show-rating') === 'true' : false;

            const elRatingStars = item.querySelector('[data-attribute="rating-stars"]');
            const ratingStars = elRatingStars ? +elRatingStars.getAttribute('data-value') : 5;

            const elRatingText = item.querySelector('[data-attribute="rating-text"]');
            const ratingText = elRatingText ? elRatingText.innerHTML.trim() : '';

            const elHeaderItem = item.querySelector('[data-attribute="header-item"]');
            const headerItem = elHeaderItem ? elHeaderItem.innerHTML.trim() : '';

            const elWrapPrice = item.querySelector('[data-attribute="wrap-price"]');
            const showPrice = elWrapPrice ? elWrapPrice.getAttribute('data-show-price') === 'true' : false;

            const elPriceNew = item.querySelector('[data-attribute="price-new"]');
            const priceNew = elPriceNew ? +elPriceNew.getAttribute('data-value') : 0;

            const elPriceOld = item.querySelector('[data-attribute="price-old"]');
            const priceOld = elPriceOld ? +elPriceOld.getAttribute('data-value') : 0;

            const elPriceSale = item.querySelector('[data-attribute="price-sale"]');
            const priceSale = elPriceSale ? elPriceSale.innerHTML.trim() : '';
            const showSave = elPriceSale ? elPriceSale.getAttribute('data-show-sale') === 'true' : false;

            const elBtnViewMore = item.querySelector('[data-attribute="btn-view-more"]');
            const btnViewMore = elBtnViewMore ? elBtnViewMore.innerHTML.trim() : 'Show Now';

            result['listItem'].push({
              image: image,
              showRating: showRating,
              ratingStars: ratingStars,
              ratingText: ratingText,
              headerItem: headerItem,
              showPrice: showPrice,
              priceNew: priceNew,
              priceOld: priceOld,
              priceSale: priceSale,
              showSave: showSave,
              btnViewMore: btnViewMore,
              link: link,
            });
          });
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionBannerKynorelle(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Banner Kynorelle Section',
      'container-page': false,
      'card-container': '#FFFFFF',
      'top-padding': false,
      'bottom-padding': false,
      'list-item': [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Banner Kynorelle Section';
    }

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result['card-container'] = cardContainer.getAttribute('data-background') || '#FFFFFF';
      result['top-padding'] = cardContainer.getAttribute('data-top-padding') === 'true';
      result['bottom-padding'] = cardContainer.getAttribute('data-bottom-padding') === 'true';
    }

    const containerPage = doc.querySelector('[data-attribute="container-page"]');
    if (containerPage) {
      result['container-page'] = containerPage.getAttribute('data-show-style') === 'true';
    }

    const listItem = doc.querySelector('[data-attribute="list-item"]');
    const itemEls = listItem ? listItem.querySelectorAll('[data-attribute="item"]') : [];
    itemEls.forEach(elItem => {
      const elSubtitleBlock = elItem.querySelector('[data-attribute="block-subtitle"]');
      const elSubtitleIcon = elItem.querySelector('[data-attribute="subtitle-icon"]');
      const elSubtitleText = elItem.querySelector('[data-attribute="text-subtitle"]');
      const elSubtitleAvatars = elItem.querySelector('[data-attribute="subtitle-avatars"]');
      const elTitleBlock = elItem.querySelector('[data-attribute="title-banner-item"]');
      const elImageDesktopWrap = elItem.querySelector('[data-attribute="image-item-banner"]');
      const elImageMobile = elItem.querySelector('[data-attribute="image-item-banner-mobile"]');
      const elBtn = elItem.querySelector('[data-attribute="button-link-item"]');
      const elOutstandingBlock = elItem.querySelector('[data-attribute="block-outstanding"]');
      const outstandingEls = elItem.querySelectorAll('[data-attribute="outstanding-item"]');

      const desktopImg = elImageDesktopWrap ? elImageDesktopWrap.querySelector('img') : null;
      const labelSpan = elBtn ? elBtn.querySelector('span:not(.icon)') : null;

      const outstanding = [];
      outstandingEls.forEach(outstandingItem => {
        const itemHeading = outstandingItem.querySelector('h2');
        const itemText = outstandingItem.querySelector('p');
        outstanding.push({
          heading: itemHeading ? itemHeading.textContent.trim() : '',
          text: itemText ? itemText.textContent.trim() : '',
        });
      });

      result['list-item'].push({
        subtitle: {
          show: elSubtitleBlock ? elSubtitleBlock.getAttribute('data-show') === 'true' : false,
          icon: elSubtitleIcon ? elSubtitleIcon.getAttribute('src') || '' : '',
          text: elSubtitleText ? elSubtitleText.textContent.trim() : '',
          avatars: elSubtitleAvatars ? elSubtitleAvatars.getAttribute('src') || '' : '',
        },
        title: {
          show: elTitleBlock ? elTitleBlock.getAttribute('data-show') === 'true' : false,
          content: elTitleBlock ? elTitleBlock.innerHTML.trim() : '',
        },
        imageDesktop: desktopImg ? desktopImg.getAttribute('src') || '' : '',
        imageMobile: elImageMobile ? elImageMobile.getAttribute('src') || '' : '',
        button: {
          show: elBtn ? elBtn.getAttribute('data-show') === 'true' : false,
          text: labelSpan ? labelSpan.textContent.trim() : '',
          link: elBtn ? elBtn.getAttribute('href') || '#' : '#',
          background: elBtn ? elBtn.getAttribute('data-background') || '#003568' : '#003568',
          color: elBtn ? elBtn.getAttribute('data-color') || '#FFFFFF' : '#FFFFFF',
        },
        blockOutstanding: {
          show: elOutstandingBlock ? elOutstandingBlock.getAttribute('data-show') === 'true' : false,
          items: outstanding,
        },
      });
    });

    if (!result['list-item'].length) {
      result['list-item'].push({
        subtitle: { show: true, icon: '', text: '', avatars: '' },
        title: { show: true, content: '' },
        imageDesktop: '',
        imageMobile: '',
        button: { show: true, text: '', link: '#', background: '#003568', color: '#FFFFFF' },
        blockOutstanding: { show: true, items: [{ heading: '', text: '' }] },
      });
    }

    return result;
  },
  sectionGridItemKynorelle(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerFuild,
      title: containerFuild.title === 'Freestyle Section' ? 'Grid Item Kynorelle Section' : containerFuild.title,
      'title-card': {
        show: false,
        content: '<h2><strong>Feels Light</strong></h2><p>Soft fabric you can wear all day without noticing.</p>',
      },
      'show-slider': false,
      'image-banner-left': '',
      'image-banner-left-link': '',
      'image-banner-right': '',
      'image-banner-right-link': '',
      'list-item': [],
    };

    const titleCardEl = doc.querySelector('[data-attribute="title-card"]');
    if (titleCardEl) {
      result['title-card'] = {
        show: titleCardEl.getAttribute('data-show') === 'true',
        content: titleCardEl.innerHTML.trim(),
      };
    }

    const imageBannerLeftLink = doc.querySelector('[data-attribute="image-banner-left-link"]');
    if (imageBannerLeftLink) {
      result['image-banner-left-link'] = imageBannerLeftLink.getAttribute('href') || '#';
    }

    const imageBannerRightLink = doc.querySelector('[data-attribute="image-banner-right-link"]');
    if (imageBannerRightLink) {
      result['image-banner-right-link'] = imageBannerRightLink.getAttribute('href') || '#';
    }

    const imageBannerLeft = doc.querySelector('[data-attribute="image-banner-left"]');
    if (imageBannerLeft) {
      result['image-banner-left'] = imageBannerLeft.getAttribute('src') || '';
    }

    const imageBannerRight = doc.querySelector('[data-attribute="image-banner-right"]');
    if (imageBannerRight) {
      result['image-banner-right'] = imageBannerRight.getAttribute('src') || '';
    }

    const wrapSlider = doc.querySelector('[data-attribute="wrap-slider"]');
    if (wrapSlider) {
      result['show-slider'] = wrapSlider.getAttribute('data-show') === 'true';
    }

    const listItem = doc.querySelectorAll('[data-attribute="image-item-slide"]');
    listItem.forEach(item => {
      result['list-item'].push({
        image: item.getAttribute('src') || '',
      });
    });

    if (!result['list-item'].length) {
      result['list-item'].push({ image: '' });
    }

    return result;
  },
  sectionGridItemKynorelle02(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Grid Item Kynorelle 02 Section',
      'top-padding': false,
      'bottom-padding': false,
      'card-container': '#FFFFFF',
      'text-color': '#000000',
      'wrap-body-background': '#003568',
      'title-card': {
        show: false,
        content: '<h2><strong>Feels Light</strong></h2><p>Soft fabric you can wear all day without noticing.</p>',
      },
      'markqueue-items': [],
      'col-perview': 3,
      'list-item': [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title || result.title;
    }

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result['card-container'] = cardContainer.getAttribute('data-background') || '#FFFFFF';
      result['text-color'] = cardContainer.getAttribute('data-color') || '#000000';
      result['top-padding'] = cardContainer.getAttribute('data-top-padding') === 'true';
      result['bottom-padding'] = cardContainer.getAttribute('data-bottom-padding') === 'true';
    }

    const titleCardEl = doc.querySelector('[data-attribute="title-card"]');
    if (titleCardEl) {
      result['title-card'] = {
        show: titleCardEl.getAttribute('data-show') === 'true',
        content: titleCardEl.innerHTML.trim(),
      };
    }

    const wrapBodySection = doc.querySelector('[data-attribute="wrap-body-section"]');
    if (wrapBodySection) {
      result['wrap-body-background'] = wrapBodySection.getAttribute('data-background') || '#003568';
    }

    const blockImgProduct = doc.querySelector('[data-attribute="block-img-product"]');
    if (blockImgProduct) {
      const colPerview = Number(blockImgProduct.getAttribute('data-col-perview'));
      result['col-perview'] = Number.isFinite(colPerview) && colPerview > 0 ? colPerview : 3;
    }

    const markqueueItems = doc.querySelectorAll('[data-attribute="item-markqueue"]');
    markqueueItems.forEach(item => {
      result['markqueue-items'].push({
        icon: item.querySelector('[data-attribute="icon-item-markqueue"]')?.getAttribute('src') || '',
        text: item.querySelector('[data-attribute="text-item-markqueue"]')?.innerHTML.trim() || '',
      });
    });

    const listItem = doc.querySelectorAll('[data-attribute="image-item-img-product"]');
    listItem.forEach(item => {
      result['list-item'].push({
        image: item.getAttribute('src') || '',
      });
    });

    if (!result['markqueue-items'].length) {
      result['markqueue-items'].push({
        icon: '',
        text: '',
      });
    }

    if (!result['list-item'].length) {
      result['list-item'].push({
        image: '',
      });
    }

    return result;
  },
  sectionMarkqueueKynorelle(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Markqueue Kynorelle Section',
      'top-padding': true,
      'bottom-padding': true,
      'card-container': '#ffffff',
      'text-color': '#ffffff',
      'background-markqueue': '#003568',
      'markqueue-items': [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title || result.title;
    }

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result['card-container'] = cardContainer.getAttribute('data-background') || '#ffffff';
      result['text-color'] = cardContainer.getAttribute('data-color') || '#ffffff';
      result['top-padding'] = cardContainer.getAttribute('data-top-padding') === 'true';
      result['bottom-padding'] = cardContainer.getAttribute('data-bottom-padding') === 'true';
    }

    const blockMarkqueue = doc.querySelector('[data-attribute="container-markqueue"]');
    if (blockMarkqueue) {
      result['background-markqueue'] = blockMarkqueue.getAttribute('data-background-markqueue') || '#003568';
    }

    const markqueueItems = doc.querySelectorAll('[data-attribute="item-markqueue"]');
    markqueueItems.forEach(item => {
      result['markqueue-items'].push({
        icon: item.querySelector('[data-attribute="icon-item-markqueue"]')?.getAttribute('src') || '',
        text: item.querySelector('[data-attribute="text-item-markqueue"]')?.innerHTML.trim() || '',
      });
    });

    if (!result['markqueue-items'].length) {
      result['markqueue-items'].push({
        icon: '',
        text: '',
      });
    }

    return result;
  },
  sectionMarqueeKyroro(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Marquee Kyroro Section',
      'top-padding': true,
      'bottom-padding': true,
      'card-container': '#ffffff',
      'text-color': '#ffffff',
      'background-markqueue': '#003568',
      'markqueue-items': [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title || result.title;
    }

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result['card-container'] = cardContainer.getAttribute('data-background') || '#ffffff';
      result['text-color'] = cardContainer.getAttribute('data-color') || '#ffffff';
      result['top-padding'] = cardContainer.getAttribute('data-top-padding') === 'true';
      result['bottom-padding'] = cardContainer.getAttribute('data-bottom-padding') === 'true';
    }

    const blockMarkqueue = doc.querySelector('[data-attribute="container-markqueue"]');
    if (blockMarkqueue) {
      result['background-markqueue'] = blockMarkqueue.getAttribute('data-background-markqueue') || '#003568';
    }

    const markqueueItems = doc.querySelectorAll('[data-attribute="item-markqueue"]');
    markqueueItems.forEach(item => {
      result['markqueue-items'].push({
        icon: item.querySelector('[data-attribute="icon-item-markqueue"]')?.getAttribute('src') || '',
        text: item.querySelector('[data-attribute="text-item-markqueue"]')?.innerHTML.trim() || '',
        link: item.getAttribute('href') || '#',
      });
    });

    if (!result['markqueue-items'].length) {
      result['markqueue-items'].push({
        icon: '',
        text: '',
        link: '#',
      });
    }

    return result;
  },
  sectionMarqueeBoxerItem(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerFuild,
      title: containerFuild.title === 'Freestyle Section' ? 'Marquee Boxer Item Section' : containerFuild.title,
      cardTitle: {
        show: true,
        content:
          '<h2>TitanBoxers</h2><p>TitanBoxers are the best boxers on the market. They are made with the best materials and are designed to fit your body perfectly.</p>',
      },
      blockMarquee: {
        colPerView: 4,
        spaceBetween: 30,
        backgroundItem: '#3c3c3c',
        radiusItem: 10,
        speed: 10,
        itemWidth: 300,
        itemGap: 30,
      },
      items: [],
    };

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle = {
        show: cardTitleEl.getAttribute('data-show') !== 'false',
        content: cardTitleEl.innerHTML.trim() || result.cardTitle.content,
      };
    }

    const blockMarqueeEl = doc.querySelector('[data-attribute="block-marquee"]');
    if (blockMarqueeEl) {
      const colPerView = Number(blockMarqueeEl.getAttribute('data-col-per-view'));
      const spaceBetween = Number(blockMarqueeEl.getAttribute('data-space-between'));
      const radiusItem = Number(blockMarqueeEl.getAttribute('data-radius-item'));
      const speed = Number(blockMarqueeEl.getAttribute('data-speed'));
      const itemWidth = Number(blockMarqueeEl.getAttribute('data-item-width'));
      const itemGap = Number(blockMarqueeEl.getAttribute('data-item-gap'));
      result.blockMarquee = {
        colPerView: Number.isFinite(colPerView) && colPerView > 0 ? colPerView : result.blockMarquee.colPerView,
        spaceBetween:
          Number.isFinite(spaceBetween) && spaceBetween >= 0 ? spaceBetween : result.blockMarquee.spaceBetween,
        backgroundItem: blockMarqueeEl.getAttribute('data-background-item') || result.blockMarquee.backgroundItem,
        radiusItem: Number.isFinite(radiusItem) && radiusItem >= 0 ? radiusItem : result.blockMarquee.radiusItem,
        speed: Number.isFinite(speed) && speed > 0 ? speed : result.blockMarquee.speed,
        itemWidth: Number.isFinite(itemWidth) && itemWidth > 0 ? itemWidth : result.blockMarquee.itemWidth,
        itemGap: Number.isFinite(itemGap) && itemGap >= 0 ? itemGap : result.blockMarquee.itemGap,
      };
    }

    const listItemEl = blockMarqueeEl
      ? Array.from(blockMarqueeEl.children).find(child => child.getAttribute('data-attribute') === 'list-item')
      : doc.querySelector('[data-attribute="list-item"]');
    const itemEls = listItemEl ? listItemEl.querySelectorAll('[data-attribute="item"]') : [];
    itemEls.forEach(item => {
      const linkEl = item.querySelector('[data-attribute="link-item"]');
      const ratingEl = item.querySelector('[data-attribute="wrap-rating"]');
      const descriptionEl = item.querySelector('[data-attribute="description-item"]');
      result.items.push({
        link: linkEl?.getAttribute('href') || '#',
        image: item.querySelector('[data-attribute="image-item"]')?.getAttribute('src') || '',
        rating: {
          show: ratingEl ? ratingEl.getAttribute('data-show') !== 'false' : true,
          value: Number(ratingEl?.getAttribute('data-value')) || 4,
        },
        description: {
          show: descriptionEl ? descriptionEl.getAttribute('data-show') !== 'false' : true,
          content: descriptionEl?.innerHTML.trim() || '',
        },
      });
    });

    if (!result.items.length) {
      result.items.push({
        link: '#',
        image: '',
        rating: {
          show: true,
          value: 4,
        },
        description: {
          show: true,
          content: '<p style="text-align: center;">Lorem, ipsum dolor sit amet consectetur adipisicing elit.</p>',
        },
      });
    }

    console.log(result);

    return result;
  },
  sectionGridItemKynorelle03(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Grid Item Kynorelle 03 Section',
      'top-padding': false,
      'bottom-padding': false,
      'card-container': '#FFFFFF',
      'text-color': '#000000',
      'title-card': {
        show: true,
        content:
          '<h2>Made For Real Comfort, Every Day</h2><p>Designed for women who want comfort that actually lasts all day.</p>',
      },
      'col-perview': 4,
      'list-item': [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title || result.title;
    }

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result['card-container'] = cardContainer.getAttribute('data-background') || '#FFFFFF';
      result['text-color'] = cardContainer.getAttribute('data-color') || '#000000';
      result['top-padding'] = cardContainer.getAttribute('data-top-padding') === 'true';
      result['bottom-padding'] = cardContainer.getAttribute('data-bottom-padding') === 'true';
    }

    const titleCardEl = doc.querySelector('[data-attribute="title-card"]');
    if (titleCardEl) {
      result['title-card'] = {
        show: titleCardEl.getAttribute('data-show') === 'true',
        content: titleCardEl.innerHTML.trim(),
      };
    }

    const listItem = doc.querySelector('[data-attribute="list-item"]');
    if (listItem) {
      const colPerView = Number(listItem.getAttribute('data-col-perview'));
      result['col-perview'] = Number.isFinite(colPerView) && colPerView > 0 ? colPerView : 4;
      const itemEls = listItem.querySelectorAll('[data-attribute="item"]');
      itemEls.forEach(item => {
        const labelProduct = item.querySelector('[data-attribute="label-product"]');
        result['list-item'].push({
          image: item.querySelector('[data-attribute="image-item-product"]')?.getAttribute('src') || '',
          label: labelProduct?.innerHTML.trim() || '',
          background: labelProduct?.getAttribute('data-background') || '#FFFFFF',
          textColor: labelProduct?.getAttribute('data-text-color') || '#000000',
        });
      });
    }

    if (!result['list-item'].length) {
      result['list-item'].push({
        image: '',
        label: '',
      });
    }

    return result;
  },
  sectionGridItemKynorelle04(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Grid Item Kynorelle 04 Section',
      'top-padding': false,
      'bottom-padding': false,
      'card-container': '#FFFFFF',
      'text-color': '#000000',
      'title-card': {
        show: true,
        content:
          '<h2>Made For Real Comfort, Every Day</h2><p>Designed for women who want comfort that actually lasts all day.</p>',
      },
      'list-item': [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title || result.title;
    }

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result['card-container'] = cardContainer.getAttribute('data-background') || '#FFFFFF';
      result['text-color'] = cardContainer.getAttribute('data-color') || '#000000';
      result['top-padding'] = cardContainer.getAttribute('data-top-padding') === 'true';
      result['bottom-padding'] = cardContainer.getAttribute('data-bottom-padding') === 'true';
    }

    const titleCardEl = doc.querySelector('[data-attribute="title-card"]');
    if (titleCardEl) {
      result['title-card'] = {
        show: titleCardEl.getAttribute('data-show') === 'true',
        content: titleCardEl.innerHTML.trim(),
      };
    }

    const listItem = doc.querySelector('[data-attribute="list-item"]');
    if (listItem) {
      const itemEls = listItem.querySelectorAll('[data-attribute="item"]');
      itemEls.forEach(item => {
        const contentReview = item.querySelector('[data-attribute="content-review"]')?.innerHTML.trim() || '';
        const image = item.querySelector('[data-attribute="image-item"]')?.getAttribute('src') || '';
        const reviewer = item.querySelector('[data-attribute="reviewer-name"]')?.textContent.trim() || '';
        result['list-item'].push({
          content: contentReview,
          image,
          reviewer,
        });
      });
    }

    if (!result['list-item'].length) {
      result['list-item'].push({
        content: '<p></p>',
        image: '',
        reviewer: '',
      });
    }

    return result;
  },
  sectionGridItemKynorelle05(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Grid Item Kynorelle 05 Section',
      'top-padding': false,
      'bottom-padding': false,
      'card-container': '#FFFFFF',
      'text-color': '#000000',
      'title-card': {
        show: true,
        content:
          '<h2>Made For Real Comfort, Every Day</h2><p>Designed for women who want comfort that actually lasts all day.</p>',
      },
      'image-heading': '',
      'text-heading': '<h2></h2><p></p>',
      'highlight-text': {
        show: true,
        content: '',
      },
      'image-content': '',
      'text-content': '<ul><li></li></ul>',
      button: {
        show: true,
        text: 'SHOP NOW',
        link: '#',
        background: '#003568',
        color: '#ffffff',
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title || result.title;
    }

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result['card-container'] = cardContainer.getAttribute('data-background') || '#FFFFFF';
      result['text-color'] = cardContainer.getAttribute('data-color') || '#000000';
      result['top-padding'] = cardContainer.getAttribute('data-top-padding') === 'true';
      result['bottom-padding'] = cardContainer.getAttribute('data-bottom-padding') === 'true';
    }

    const titleCardEl = doc.querySelector('[data-attribute="title-card"]');
    if (titleCardEl) {
      result['title-card'] = {
        show: titleCardEl.getAttribute('data-show') === 'true',
        content: titleCardEl.innerHTML.trim(),
      };
    }

    const imageHeading = doc.querySelector('[data-attribute="image-heading"]');
    if (imageHeading) {
      result['image-heading'] = imageHeading.getAttribute('src') || '';
    }

    const textHeading = doc.querySelector('[data-attribute="text-heading"]');
    if (textHeading) {
      result['text-heading'] = textHeading.innerHTML.trim();
    }

    const highlightText = doc.querySelector('[data-attribute="highlight-text"]');
    if (highlightText) {
      result['highlight-text'] = {
        show: highlightText.getAttribute('data-show') === 'true',
        content: highlightText.innerHTML.trim(),
      };
    }

    const imageContent = doc.querySelector('[data-attribute="image-content"]');
    if (imageContent) {
      result['image-content'] = imageContent.getAttribute('src') || '';
    }

    const textContent = doc.querySelector('[data-attribute="text-content"]');
    if (textContent) {
      result['text-content'] = textContent.innerHTML.trim();
    }

    const button = doc.querySelector('[data-attribute="button-link"]');
    if (button) {
      result.button = {
        show: button.getAttribute('data-show') === 'true',
        text: button.querySelector('span:not(.icon)')?.textContent.trim() || '',
        link: button.getAttribute('href') || '#',
        background: button.getAttribute('data-background') || '#003568',
        color: button.getAttribute('data-color') || '#ffffff',
      };
    }

    return result;
  },
  sectionTextWithIcon(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerFuild,
      title: containerFuild.title === 'Freestyle Section' ? 'Text With Icon Section' : containerFuild.title,
      bgIcon: '#003568',
      colPerView: 4,
      titleCard: {
        show: true,
        content: '<h2>text with icon</h2><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>',
      },
      items: [],
    };

    const listItemEl = doc.querySelector('[data-attribute="list-item"]');
    if (listItemEl) {
      const bgIcon = listItemEl.getAttribute('data-bg-icon');
      if (bgIcon) result.bgIcon = bgIcon;
      const colPerView = Number(listItemEl.getAttribute('data-col-perview'));
      if (Number.isFinite(colPerView) && colPerView > 0) result.colPerView = colPerView;
    }

    const titleCardEl = doc.querySelector('[data-attribute="title-card"]');
    if (titleCardEl) {
      result.titleCard = {
        show: titleCardEl.getAttribute('data-show') !== 'false',
        content: titleCardEl.innerHTML.trim() || result.titleCard.content,
      };
    }

    const itemEls = listItemEl ? listItemEl.querySelectorAll('[data-attribute="item"]') : [];
    itemEls.forEach(elItem => {
      const elIconImage = elItem.querySelector('[data-attribute="icon-image"]');
      const elTextItem = elItem.querySelector('[data-attribute="text-item"]');
      result.items.push({
        icon: elIconImage ? elIconImage.getAttribute('src') || '' : '',
        content: elTextItem ? elTextItem.innerHTML.trim() : '',
      });
    });

    if (!result.items.length) {
      result.items.push({
        icon: '',
        content: '<h3>Heading</h3><p>Description</p>',
      });
    }

    return result;
  },
  sectionCardHsiaTextWithIcon(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Hsia Text With Icon Section',
      styleSection: {
        topPadding: true,
        bottomPadding: true,
        background: '#FFFFFF',
        textColor: '#000000',
      },
      containerPage: {
        enableStyle: false,
        background: '#FFFFFF',
      },
      cardTitle: {
        show: true,
        content: '<h2>Title</h2><p>Description</p>',
      },
      listStyle: {
        bgItemColor: '#F5F5F5',
        borderItemRadius: 10,
      },
      items: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.title = sectionEl.getAttribute('data-title') || result.title;
    }

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result.styleSection.topPadding = cardContainer.getAttribute('data-top-padding') === 'true';
      result.styleSection.bottomPadding = cardContainer.getAttribute('data-bottom-padding') === 'true';
      result.styleSection.background = cardContainer.getAttribute('data-background') || '#FFFFFF';
      result.styleSection.textColor = cardContainer.getAttribute('data-text-color') || '#000000';
    }

    const containerPage = doc.querySelector('[data-attribute="container-page"]');
    if (containerPage) {
      result.containerPage.enableStyle = containerPage.getAttribute('data-enable-style') === 'true';
      result.containerPage.background = containerPage.getAttribute('data-background-container') || '#FFFFFF';
    }

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim() || '';
    }

    const listEl = doc.querySelector('[data-attribute="list-item"]');
    if (listEl) {
      result.listStyle.bgItemColor = listEl.getAttribute('data-bg-item-color') || '#F5F5F5';
      result.listStyle.borderItemRadius = Number(listEl.getAttribute('data-border-item-radius')) || 10;
    }

    const items =
      Array.from(doc.querySelectorAll('[data-attribute="item"]'))?.map(item => ({
        link: item.getAttribute('href') || '#',
        image: item.querySelector('[data-attribute="image-item"]')?.getAttribute('src') || '',
        content: item.querySelector('[data-attribute="text-item"]')?.innerHTML?.trim() || '',
      })) || [];

    if (items.length) {
      result.items = items;
    } else {
      result.items = [
        {
          link: '#',
          image: '',
          content: '<h3>Heading</h3><p>Description</p>',
        },
      ];
    }

    return result;
  },
  sectionProductWithVariant(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Product With Variant Section',
      cardTitle: '',
      showCardTitle: true,
      styleSection: {
        topPadding: true,
        bottomPadding: true,
        background: '#FFFFFF',
        textColor: '#000000',
      },
      containerPage: {
        enableStyle: false,
        background: '#FFFFFF',
      },
      colPerView: 4,
      spaceBetween: 25,
      listItem: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.title = sectionEl.getAttribute('data-title') || result.title;
    }

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result.styleSection.topPadding = cardContainer.getAttribute('data-top-padding') === 'true';
      result.styleSection.bottomPadding = cardContainer.getAttribute('data-bottom-padding') === 'true';
      result.styleSection.background = cardContainer.getAttribute('data-background') || '#FFFFFF';
      result.styleSection.textColor = cardContainer.getAttribute('data-text-color') || '#000000';
    }

    const containerPage = doc.querySelector('[data-attribute="container-page"]');
    if (containerPage) {
      result.containerPage.enableStyle = containerPage.getAttribute('data-enable-style') === 'true';
      result.containerPage.background = containerPage.getAttribute('data-background-container') || '#FFFFFF';
    }

    const cardTitle = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitle) {
      result.cardTitle = cardTitle.innerHTML.trim();
      result.showCardTitle = cardTitle.getAttribute('data-show') === 'true';
    }

    const listItem = doc.querySelector('[data-attribute="list-item"]');
    if (listItem) {
      const colPerView = Number(listItem.getAttribute('data-col-perview'));
      if (Number.isFinite(colPerView) && colPerView > 0) {
        result.colPerView = colPerView;
      }
      const spaceBetween = Number(listItem.getAttribute('data-space-between'));
      if (Number.isFinite(spaceBetween) && spaceBetween >= 0) {
        result.spaceBetween = spaceBetween;
      }
    }

    const items = Array.from(doc.querySelectorAll('[data-attribute="product-item"]'));
    items.forEach(item => {
      const productName = item.querySelector('[data-attribute="product-name"]')?.innerHTML?.trim() || '';
      const productPrice = {
        fromText: item.querySelector('[data-attribute="from-text"]')?.textContent?.trim() || 'From',
        priceNew: item.querySelector('[data-attribute="price-new"]')?.textContent?.trim() || '',
        priceOld: item.querySelector('[data-attribute="price-old"]')?.textContent?.trim() || '',
        stateProduct: item.querySelector('[data-attribute="state-product"]')?.textContent?.trim() || '',
      };
      const rating = {
        value: Number(item.querySelector('[data-attribute="stars"]')?.getAttribute('data-value') || 5),
        reviewCount: item.querySelector('[data-attribute="review-count"]')?.textContent?.trim() || '4 reviews',
      };

      const imagesWrap = item.querySelector('[data-attribute="list-img-color-variant"]');
      const swatchWrap = item.querySelector('[data-attribute="list-color-variant"]');

      const linkProduct = imagesWrap ? imagesWrap.getAttribute('href') || '#' : '#';

      const swatchByKey = {};
      if (swatchWrap) {
        Array.from(swatchWrap.querySelectorAll('[data-attribute="color-variant"]')).forEach(swatch => {
          const key = swatch.getAttribute('data-color-variant');
          const useThumbnail = swatch.getAttribute('data-use-thumbnail') === 'true';
          const imageThumbnail =
            swatch.querySelector('[data-attribute="thumbnail-color-variant"]')?.getAttribute('src') || '';
          if (!key) return;
          swatchByKey[key] = {
            label: swatch.getAttribute('data-label') || '',
            soldOut: swatch.getAttribute('data-sold-out') === 'true',
            useThumbnail: useThumbnail,
            thumbnail: imageThumbnail,
            active:
              swatch.getAttribute('data-active') === 'true' || (swatch.getAttribute('class') || '').includes('active'),
          };
        });
      }

      const colorVariants = {};
      if (imagesWrap) {
        Array.from(imagesWrap.querySelectorAll(':scope > [data-attribute="color-variant"]')).forEach(group => {
          const key = group.getAttribute('data-color-variant');
          if (!key) return;
          const swatchInfo = swatchByKey[key] || {};
          const useThumbnail = swatchInfo.useThumbnail;
          const thumbnail = swatchInfo.thumbnail;
          const images = Array.from(group.querySelectorAll('[data-attribute="image-color-variant"]')).map(img => ({
            image: img.getAttribute('src') || '',
          }));
          colorVariants[key] = {
            color: group.getAttribute('data-color') || '#000000',
            label: swatchInfo.label || key,
            soldOut: !!swatchInfo.soldOut,
            active:
              !!swatchInfo.active ||
              group.getAttribute('data-active') === 'true' ||
              (group.getAttribute('class') || '').includes('active'),
            useThumbnail: useThumbnail,
            thumbnail: thumbnail,
            images: images.length ? images : [{ image: '' }],
          };
        });
      }

      result.listItem.push({
        productName,
        linkProduct,
        productPrice,
        colorVariants,
        rating,
      });
    });

    if (!result.listItem.length) {
      result.listItem.push({
        productName: '',
        linkProduct: '#',
        productPrice: { fromText: 'From', priceNew: '', priceOld: '', stateProduct: '' },
        colorVariants: {},
        rating: { value: 5, reviewCount: '4 reviews' },
      });
    }

    return result;
  },
  sectionSliderItemFyroro(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Slider Item Fyroro Section',
      titleCard: '',
      settings: {
        paddingTop: true,
        paddingBottom: true,
        backgroundColor: '#FFFFFF',
        textColor: '#000000',
      },
      slider: {
        slidesPerView: 3,
        showPrice: true,
        showDiscountTag: true,
        discountBg: '#6293c1',
        discountColor: '#ffffff',
      },
      button: {
        show: true,
        text: 'View All',
        link: 'javascript:void(0)',
        background: '#000000',
        color: '#ffffff',
        radius: '0',
      },
      listItem: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title || result.title;
    }

    const titleCard = doc.querySelector('[data-attribute="title-card"]');
    if (titleCard) {
      result.titleCard = titleCard.innerHTML.trim() || '';
    }

    const sliderProduct = doc.querySelector('[data-attribute="slider-product"]');
    if (sliderProduct) {
      result.slider = {
        slidesPerView: Number(sliderProduct.getAttribute('data-slide-per-view') || 3),
        showPrice: sliderProduct.getAttribute('data-show-price') !== 'false',
        showDiscountTag: sliderProduct.getAttribute('data-show-discount-tag') !== 'false',
        discountBg: sliderProduct.getAttribute('data-background-discount-tag') || '#6293c1',
        discountColor: sliderProduct.getAttribute('data-color-discount-tag') || '#ffffff',
      };
    }

    const buttonWrap = doc.querySelector('.wrap-btn');
    const buttonEl = doc.querySelector('[data-attribute="btn-view-all"]');
    if (buttonWrap || buttonEl) {
      result.button = {
        show: buttonWrap ? buttonWrap.getAttribute('data-show-btn') !== 'false' : true,
        text: buttonEl?.textContent.trim() || 'View All',
        link: buttonEl?.getAttribute('href') || 'javascript:void(0)',
        background: buttonEl?.getAttribute('data-background') || '#000000',
        color: buttonEl?.getAttribute('data-color') || '#ffffff',
        radius: buttonEl?.getAttribute('data-radius') || '0',
      };
    }

    const itemEls = doc.querySelectorAll('[data-attribute="item-product"]');
    itemEls.forEach(item => {
      const saveDiscount = item.querySelector('[data-attribute="save-discount"]');
      result.listItem.push({
        image: item.querySelector('[data-attribute="image-product"]')?.getAttribute('src') || '',
        showDiscount: saveDiscount ? saveDiscount.getAttribute('data-show') !== 'false' : true,
        discountText: item.querySelector('[data-attribute="text-discount"]')?.textContent.trim() || 'Save 20%',
        productName: item.querySelector('[data-attribute="product-name"]')?.textContent.trim() || '',
        fromText: item.querySelector('[data-attribute="from-text"]')?.textContent.trim() || 'From',
        priceNew: item.querySelector('[data-attribute="price-new"]')?.textContent.trim() || '$0.00',
        priceOld: item.querySelector('[data-attribute="price-old"]')?.textContent.trim() || '$0.00',
        link: item.getAttribute('href') || '#',
      });
    });

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result.settings.backgroundColor = cardContainer.getAttribute('data-background') || '#FFFFFF';
      result.settings.textColor = cardContainer.getAttribute('data-text-color') || '#000000';
      result.settings.paddingTop = cardContainer.getAttribute('data-top-padding') === 'true' ? true : false;
      result.settings.paddingBottom = cardContainer.getAttribute('data-bottom-padding') === 'true' ? true : false;
    }

    if (!result.listItem.length) {
      result.listItem.push({
        image: '',
        showDiscount: true,
        discountText: 'Save 20%',
        productName: '',
        fromText: 'From',
        priceNew: '$0.00',
        priceOld: '$0.00',
        link: '#',
      });
    }

    return result;
  },
  sectionSliderItemBoxer(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Slider Item Boxer Section',
      styleSection: {
        topPadding: true,
        bottomPadding: true,
        background: '#FFFFFF',
        textColor: '#000000',
      },
      containerPage: {
        enableStyle: false,
        background: '#FFFFFF',
      },
      titleCard: {
        show: true,
        content: '<h2>Title</h2><p>Description</p>',
      },
      wrapItems: {
        colPerView: 3,
        spaceBetween: 30,
        itemBackground: '#eff3fa',
        itemBorderRadius: 10,
        colorStar: '#FFD700',
      },
      listItem: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.title = sectionEl.getAttribute('data-title') || result.title;
    }

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result.styleSection.topPadding = cardContainer.getAttribute('data-top-padding') === 'true';
      result.styleSection.bottomPadding = cardContainer.getAttribute('data-bottom-padding') === 'true';
      result.styleSection.background = cardContainer.getAttribute('data-background') || '#FFFFFF';
      result.styleSection.textColor = cardContainer.getAttribute('data-text-color') || '#000000';
    }

    const containerPage = doc.querySelector('[data-attribute="container-page"]');
    if (containerPage) {
      result.containerPage.enableStyle = containerPage.getAttribute('data-enable-style') === 'true';
      result.containerPage.background = containerPage.getAttribute('data-background-container') || '#FFFFFF';
    }

    const titleCardEl = doc.querySelector('[data-attribute="title-card"]');
    if (titleCardEl) {
      result.titleCard.show = titleCardEl.getAttribute('data-show') !== 'false';
      result.titleCard.content = titleCardEl.innerHTML.trim() || result.titleCard.content;
    }

    const wrapItemsEl = doc.querySelector('[data-attribute="wrap-items"]');
    if (wrapItemsEl) {
      result.wrapItems.colPerView = Number(wrapItemsEl.getAttribute('data-col-per-view')) || 3;
      result.wrapItems.spaceBetween = Number(wrapItemsEl.getAttribute('data-space-between')) || 30;
      result.wrapItems.itemBackground = wrapItemsEl.getAttribute('data-item-background') || '#eff3fa';
      result.wrapItems.itemBorderRadius = Number(wrapItemsEl.getAttribute('data-item-border-radius')) || 10;
      result.wrapItems.colorStar = wrapItemsEl.getAttribute('data-color-star') || '#FFD700';
    }

    const itemEls = doc.querySelectorAll('[data-attribute="item"]');
    itemEls.forEach(item => {
      const imageEl = item.querySelector('[data-attribute="image-item"]');
      const ratingEl = item.querySelector('[data-attribute="wrap-rating"]');
      const descEl = item.querySelector('[data-attribute="description-item"]');
      const linkEl = item.querySelector('[data-attribute="link-item"]');

      result.listItem.push({
        image: imageEl?.getAttribute('src') || '',
        rating: {
          show: ratingEl ? ratingEl.getAttribute('data-show') !== 'false' : true,
          value: Number(ratingEl?.getAttribute('data-value')) || 4,
        },
        description: {
          show: descEl ? descEl.getAttribute('data-show') !== 'false' : true,
          text: descEl?.innerHTML.trim() || '',
        },
        link: linkEl?.getAttribute('href') || '#',
      });
    });

    if (!result.listItem.length) {
      result.listItem.push({
        image: '',
        rating: { show: true, value: 4 },
        description: { show: true, text: '' },
        link: '#',
      });
    }

    console.log(result);

    return result;
  },
  sectionFreestyle(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerFuild,
      content: '',
    };
    const content = doc.querySelector('[data-attribute="content"]');
    if (content) {
      result.content = content.innerHTML.trim() || result.content;
    }
    return result;
  },
  sectionCardGridBoxer(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerFuild,
      title: containerFuild.title === 'Freestyle Section' ? 'Card Grid Boxer Section' : containerFuild.title,
      titleCard: {
        show: true,
        content:
          "<h2>4 Reasons Why</h2><h3>TitanBoxers Aren't Like Any Boxer You've Worn Before</h3><p>If you've spent years settling for standard cotton or struggling with bulky \"medical\" solutions, your first day in an ICEMAX boxer will be a revelation.</p>",
      },
      listItem: {
        colPerView: 4,
        spaceBetween: 30,
        sttShow: true,
        sttBackground: '#606f99',
        sttColor: '#FFFFFF',
        items: [],
      },
      button: {
        show: true,
        text: 'TRY IT TODAY, RISK-FREE !',
        link: '#',
        background: '#606f99',
        color: '#FFFFFF',
        radius: 6,
      },
      policy: {
        show: true,
        colPerView: 2,
        items: [],
      },
    };

    const titleCardEl = doc.querySelector('[data-attribute="title-card"]');
    if (titleCardEl) {
      result.titleCard = {
        show: titleCardEl.getAttribute('data-show') !== 'false',
        content: titleCardEl.innerHTML.trim() || result.titleCard.content,
      };
    }

    const listItemEl = doc.querySelector('[data-attribute="list-item"]');
    if (listItemEl) {
      const colPerView = Number(listItemEl.getAttribute('data-col-perview'));
      const spaceBetween = Number(listItemEl.getAttribute('data-space-between'));
      result.listItem.colPerView = Number.isFinite(colPerView) && colPerView > 0 ? colPerView : 4;
      result.listItem.spaceBetween = Number.isFinite(spaceBetween) && spaceBetween >= 0 ? spaceBetween : 30;
      result.listItem.sttShow = listItemEl.getAttribute('data-show-stt') !== 'false';
      result.listItem.sttBackground = listItemEl.getAttribute('data-background-stt') || result.listItem.sttBackground;
      result.listItem.sttColor = listItemEl.getAttribute('data-color-stt') || result.listItem.sttColor;
      const itemEls = listItemEl.querySelectorAll('[data-attribute="item"]');
      itemEls.forEach(item => {
        result.listItem.items.push({
          image: item.querySelector('[data-attribute="image-item"]')?.getAttribute('src') || '',
          stt: item.querySelector('[data-attribute="stt-item"]')?.textContent.trim() || '',
          text: item.querySelector('[data-attribute="text-item"]')?.innerHTML.trim() || '',
        });
      });
    }
    if (!result.listItem.items.length) {
      result.listItem.items.push({ image: '', stt: '1', text: '<h2></h2><p></p>' });
    }

    const btnEl = doc.querySelector('[data-attribute="btn"]');
    if (btnEl) {
      const btnTextEl = btnEl.querySelector('[data-attribute="btn-text"]');
      const radiusValue = Number(btnEl.getAttribute('data-radius-btn'));
      result.button = {
        show: btnEl.getAttribute('data-show') !== 'false',
        text: btnTextEl ? btnTextEl.textContent.trim() : result.button.text,
        link: btnEl.getAttribute('href') || '#',
        background: btnEl.getAttribute('data-background-btn') || result.button.background,
        color: btnEl.getAttribute('data-color-btn') || result.button.color,
        radius: Number.isFinite(radiusValue) ? radiusValue : result.button.radius,
      };
    }

    const policyEl = doc.querySelector('[data-attribute="policy-sub"]');
    if (policyEl) {
      const policyCol = Number(policyEl.getAttribute('data-col-perview'));
      result.policy.show = policyEl.getAttribute('data-show') !== 'false';
      result.policy.colPerView = Number.isFinite(policyCol) && policyCol > 0 ? policyCol : 2;
      const policyItems = policyEl.querySelectorAll('[data-attribute="policy-item"]');
      policyItems.forEach(item => {
        result.policy.items.push({
          icon: item.querySelector('[data-attribute="icon-image"]')?.getAttribute('src') || '',
          text: item.querySelector('[data-attribute="policy-text"]')?.innerHTML.trim() || '',
        });
      });
    }
    if (!result.policy.items.length) {
      result.policy.items.push({ icon: '', text: '' });
    }

    return result;
  },
  sectionCardWithTabsBoxer(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerFuild,
      titleCard: {
        show: true,
        content:
          '<h2 style="text-align: center;">What Men Say After Switching</h2><p style="text-align: center;">Thousands of men have already made the switch.</p>',
      },
      listTabNav: {
        navColor: '#606F99',
        activeNavColor: '#ffffff',
        activeNavBackground: '#606F99',
        navBackground: '#ffffff',
        navBorderRadius: 5,
      },
      listTabContent: {
        colPerView: 4,
        spaceBetween: 30,
        borderRadius: 0,
        background: '#ffffff',
        border: '#eff3fa',
        colorItem: '#000000',
      },
      tabs: [],
    };

    const titleCardEl = doc.querySelector('[data-attribute="title-card"]');
    if (titleCardEl) {
      result.titleCard = {
        show: titleCardEl.getAttribute('data-show') !== 'false',
        content: titleCardEl.innerHTML.trim() || result.titleCard.content,
      };
    }

    const listTabNavEl = doc.querySelector('[data-attribute="list-tab-nav"]');
    if (listTabNavEl) {
      result.listTabNav.navColor = listTabNavEl.getAttribute('data-color-tab-nav') || result.listTabNav.navColor;
      result.listTabNav.navBackground =
        listTabNavEl.getAttribute('data-background-tab-nav') || result.listTabNav.navBackground;
      result.listTabNav.navBorderRadius =
        Number(listTabNavEl.getAttribute('data-border-radius-tab-nav')) >= 0
          ? Number(listTabNavEl.getAttribute('data-border-radius-tab-nav'))
          : 5;
      result.listTabNav.activeNavColor =
        listTabNavEl.getAttribute('data-active-color-tab-nav') || result.listTabNav.activeNavColor;
      result.listTabNav.activeNavBackground =
        listTabNavEl.getAttribute('data-active-background-tab-nav') || result.listTabNav.activeNavBackground;
    }

    const listContentEl = doc.querySelector('[data-attribute="list-tab-content"]');
    if (listContentEl) {
      const colPerView = Number(listContentEl.getAttribute('data-col-per-view'));
      const spaceBetween = Number(listContentEl.getAttribute('data-space-between'));
      const borderRadius = Number(listContentEl.getAttribute('data-border-radius'));
      const colorItem = listContentEl.getAttribute('data-color-item') || result.listTabContent.colorItem;
      result.listTabContent.colPerView =
        Number.isFinite(colPerView) && colPerView > 0 ? colPerView : result.listTabContent.colPerView;
      result.listTabContent.spaceBetween =
        Number.isFinite(spaceBetween) && spaceBetween >= 0 ? spaceBetween : result.listTabContent.spaceBetween;
      result.listTabContent.borderRadius =
        Number.isFinite(borderRadius) && borderRadius >= 0 ? borderRadius : result.listTabContent.borderRadius;
      result.listTabContent.background =
        listContentEl.getAttribute('data-background') || result.listTabContent.background;
      result.listTabContent.border = listContentEl.getAttribute('data-border') || result.listTabContent.border;
      result.listTabContent.colorItem = colorItem;
    }

    const tabNavEls = doc.querySelectorAll('[data-attribute="list-tab-nav"] [data-attribute="tab-nav-item"]');
    const tabContentEls = doc.querySelectorAll('[data-attribute="list-tab-content"] [data-attribute="tab-content"]');
    const contentByKey = {};
    tabContentEls.forEach(el => {
      const key = el.getAttribute('data-tab');
      if (!key) return;
      const reviews = [];
      el.querySelectorAll('[data-attribute="child-item"]').forEach(child => {
        const reviewEl = child.querySelector('[data-attribute="review"]');
        const avatarEl = child.querySelector('[data-attribute="avatar"] img');
        const usernameEl = child.querySelector('[data-attribute="username"]');
        const verifiedEl = child.querySelector('[data-attribute="verified"]');
        const verifiedIconEl = child.querySelector('[data-attribute="verified-icon"]');
        const verifiedTextEl = child.querySelector('[data-attribute="verified-text"]');
        reviews.push({
          review: reviewEl ? reviewEl.innerHTML.trim() : '',
          avatar: avatarEl ? avatarEl.getAttribute('src') || '' : '',
          username: usernameEl ? usernameEl.textContent.trim() : '',
          verifiedShow: verifiedEl ? verifiedEl.getAttribute('data-show') !== 'false' : true,
          verifiedIcon: verifiedIconEl ? verifiedIconEl.getAttribute('src') || '' : '',
          verifiedText: verifiedTextEl ? verifiedTextEl.textContent.trim() : 'Verified Buyer',
        });
      });
      contentByKey[key] = reviews;
    });

    tabNavEls.forEach((nav, index) => {
      const key = nav.getAttribute('data-tab') || `tab-${index + 1}`;
      result.tabs.push({
        key,
        label: nav.textContent.trim(),
        active: nav.classList.contains('active'),
        reviews: contentByKey[key] || [],
      });
    });

    if (!result.tabs.length) {
      result.tabs.push({
        key: 'tab-1',
        label: 'Tab 1',
        active: true,
        reviews: [
          {
            review: '<p></p>',
            avatar: '',
            username: '',
            verifiedShow: true,
            verifiedIcon: '',
            verifiedText: 'Verified Buyer',
          },
        ],
      });
    }

    if (!result.tabs.some(tab => tab.active)) {
      result.tabs[0].active = true;
    }

    return result;
  },

  sectionCardMultiBoxer(htmlString) {
    function buildMultiBoxerSlideDefault() {
      return {
        media: { type: 'image', order: 1, image: '', video: '' },
        centerY: false,
        gutter: 30,
        mediaWidth: '50%',
        content: {
          order: 2,
          titleDescription: {
            show: true,
            content:
              '<h2>Dermatologist-Backed Comfort You Can Trust</h2><p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>',
          },
          survey: {
            show: true,
            colorPercent: '#606F99',
            title: '<h3>Our Boxers are Loved by Parents</h3>',
            items: [{ percent: 90, description: '' }],
          },
          accordion: {
            show: true,
            items: [{ title: 'Question', content: 'Answer' }],
          },
          itemsWithIcon: {
            show: true,
            items: [{ icon: '', title: '', description: '' }],
          },
          button: {},
        },
      };
    }
    function parseMultiBoxerSlideItem(itemEl) {
      const slide = buildMultiBoxerSlideDefault();
      slide.centerY = itemEl.getAttribute('data-center-y') === 'true';
      slide.useCustomWidthMedia = itemEl.getAttribute('data-use-custom-width-media') === 'true';
      slide.gutter = Number(itemEl.getAttribute('data-gutter')) || 30;
      slide.mediaWidth = Number(itemEl.getAttribute('data-media-width')) || 50;
      slide.content.survey.items = [];
      slide.content.accordion.items = [];
      slide.content.itemsWithIcon.items = [];

      const mediaEl = itemEl.querySelector('[data-attribute="media"]');
      if (mediaEl) {
        const mediaOrder = Number(mediaEl.getAttribute('data-order')) || 1;
        slide.media.order = mediaOrder;
        slide.media.type = mediaEl.getAttribute('data-media-type') || 'image';
        const imgEl = mediaEl.querySelector('[data-attribute="image-item"]');
        const videoEl = mediaEl.querySelector('[data-attribute="video-item"]');
        slide.media.image = imgEl?.getAttribute('src') || '';
        slide.media.video = videoEl?.getAttribute('src') || '';
      }

      const contentEl = itemEl.querySelector('[data-attribute="content"]');
      if (contentEl) {
        const contentOrder = Number(contentEl.getAttribute('data-order'));
        slide.content.order = contentOrder || 2;
      }

      const titleDescEl = itemEl.querySelector('[data-attribute="title-description"]');
      if (titleDescEl) {
        slide.content.titleDescription.show = titleDescEl.getAttribute('data-show') !== 'false';
        slide.content.titleDescription.content = titleDescEl.innerHTML.trim() || slide.content.titleDescription.content;
      }

      const surveyEl = itemEl.querySelector('[data-attribute="wrap-survey"]');
      if (surveyEl) {
        slide.content.survey.show = surveyEl.getAttribute('data-show') !== 'false';
        slide.content.survey.colorPercent =
          surveyEl.getAttribute('data-color-percent') || slide.content.survey.colorPercent;
        const surveyTitleEl = surveyEl.querySelector('[data-attribute="survey-title"]');
        if (surveyTitleEl) {
          slide.content.survey.title = surveyTitleEl.innerHTML.trim() || slide.content.survey.title;
        }
        surveyEl.querySelectorAll('[data-attribute="item-survay"]').forEach(item => {
          const percentEl = item.querySelector('[data-attribute="percent-survay"]');
          const descEl = item.querySelector('[data-attribute="description-survay"]');
          const percent = Number(percentEl?.textContent.trim());
          slide.content.survey.items.push({
            percent: Number.isFinite(percent) ? percent : 0,
            description: descEl ? descEl.innerHTML.trim() : '',
          });
        });
      }
      if (!slide.content.survey.items.length) slide.content.survey.items.push({ percent: 90, description: '' });

      const accordionEl = itemEl.querySelector('[data-attribute="wrap-accordion"]');
      if (accordionEl) {
        slide.content.accordion.show = accordionEl.getAttribute('data-show') !== 'false';
        accordionEl.querySelectorAll('[data-attribute="accordion-item"]').forEach(item => {
          const titleEl = item.querySelector('[data-attribute="accordion-title-text"]');
          const contentTextEl = item.querySelector('[data-attribute="accordion-text"]');
          slide.content.accordion.items.push({
            title: titleEl ? titleEl.innerHTML.trim() : '',
            content: contentTextEl ? contentTextEl.innerHTML.trim() : '',
          });
        });
      }
      if (!slide.content.accordion.items.length) slide.content.accordion.items.push({ title: '', content: '' });

      const itemsWithIconEl = itemEl.querySelector('[data-attribute="wrap-item-with-icon"]');
      if (itemsWithIconEl) {
        slide.content.itemsWithIcon.show = itemsWithIconEl.getAttribute('data-show') !== 'false';
        itemsWithIconEl.querySelectorAll('[data-attribute="item-with-icon"]').forEach(item => {
          const iconEl = item.querySelector('[data-attribute="icon-with-icon-image"]');
          const titleEl = item.querySelector('[data-attribute="title-with-icon"]');
          const descEl = item.querySelector('[data-attribute="description-with-icon"]');
          slide.content.itemsWithIcon.items.push({
            icon: iconEl?.getAttribute('src') || '',
            title: titleEl ? titleEl.innerHTML.trim() : '',
            description: descEl ? descEl.innerHTML.trim() : '',
          });
        });
      }
      if (!slide.content.itemsWithIcon.items.length) {
        slide.content.itemsWithIcon.items.push({ icon: '', title: '', description: '' });
      }

      const buttonInsideEl = itemEl.querySelector('[data-attribute="wrap-btn-dynamic"]');
      if (buttonInsideEl) {
        slide.content.button = extractButtonBasic(buttonInsideEl.outerHTML);
      }

      return slide;
    }
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerFuild,
      titleCard: {
        show: true,
        content: '',
      },
      items: [],
      buttonOutSide: {},
    };

    const titleCardEl = doc.querySelector('[data-attribute="card-title"]');
    if (titleCardEl) {
      result.titleCard.show = titleCardEl.getAttribute('data-show') !== 'false';
      result.titleCard.content = titleCardEl.innerHTML.trim() || result.titleCard.content;
    }

    const itemEls = doc.querySelectorAll('[data-attribute="list-item"] [data-attribute="item"]');
    itemEls.forEach(itemEl => {
      result.items.push(parseMultiBoxerSlideItem(itemEl));
    });

    if (!result.items.length) {
      result.items.push(buildMultiBoxerSlideDefault());
    }

    const buttonOutSideEl = doc.querySelector('[data-attribute="wrap-btn-dynamic-primary"]');

    if (buttonOutSideEl) {
      result.buttonOutSide = extractButtonBasic(buttonOutSideEl.outerHTML);
    }

    return result;
  },

  sectionCardReviewsBoxer(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerFuild,
      titleCard: {
        show: true,
        content: '<h2>125K +</h2><h2>Happy Customers</h2>',
      },
      list: {
        colPerView: 4,
        spaceBetween: 16,
        colorStar: '#FFD700',
        items: [],
      },
      buttonOutSide: {},
    };

    const titleCardEl = doc.querySelector('[data-attribute="card-title"]');
    if (titleCardEl) {
      result.titleCard.show = titleCardEl.getAttribute('data-show') !== 'false';
      result.titleCard.content = titleCardEl.innerHTML.trim() || result.titleCard.content;
    }

    const listEl = doc.querySelector('[data-attribute="list-item"]');
    if (listEl) {
      result.list.colPerView = Number(listEl.getAttribute('data-col-per-view')) || result.list.colPerView;
      result.list.spaceBetween = Number(listEl.getAttribute('data-space-between')) || result.list.spaceBetween;
      result.list.colorStar = listEl.getAttribute('data-color-star') || result.list.colorStar;
    }

    const itemEls = doc.querySelectorAll('[data-attribute="list-item"] [data-attribute="item"]');
    itemEls.forEach(itemEl => {
      const imgEl = itemEl.querySelector('[data-attribute="image-item"]');
      const starsEl = itemEl.querySelector('[data-attribute="stars-item"]');
      const commentEl = itemEl.querySelector('[data-attribute="comment-item"]');
      const reviewerEl = itemEl.querySelector('[data-attribute="reviewer"]');
      const verifiedEl = itemEl.querySelector('[data-attribute="verified"]');

      const starsValue = Number(starsEl?.getAttribute('data-value'));
      result.list.items.push({
        image: imgEl?.getAttribute('src') || '',
        stars: Number.isFinite(starsValue) ? Math.max(0, Math.min(5, starsValue)) : 5,
        comment: commentEl ? commentEl.innerHTML.trim() : '',
        reviewer: reviewerEl ? reviewerEl.innerHTML.trim() : '',
        showVerified: verifiedEl ? verifiedEl.getAttribute('data-show') !== 'false' : true,
      });
    });

    if (!result.list.items.length) {
      result.list.items.push({
        image: '',
        stars: 5,
        comment: '<h3>"Great product"</h3><p>"Highly recommended."</p>',
        reviewer: 'Customer',
        showVerified: true,
      });
    }

    const buttonOutSideEl = doc.querySelector('[data-attribute="wrap-btn-dynamic-primary"]');
    if (buttonOutSideEl) {
      result.buttonOutSide = extractButtonBasic(buttonOutSideEl.outerHTML);
    }

    return result;
  },

  sectionSliderBoxerProduct(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerFuild,
      titleCard: {
        show: true,
        content:
          '<h2>Shop All Products</h2><p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.</p>',
      },
      list: {
        colPerView: 3,
        spaceBetween: 16,
        items: [],
      },
      buttonOutSide: {},
    };

    const titleCardEl = doc.querySelector('[data-attribute="card-title"]');
    if (titleCardEl) {
      result.titleCard.show = titleCardEl.getAttribute('data-show') !== 'false';
      result.titleCard.content = titleCardEl.innerHTML.trim() || result.titleCard.content;
    }

    const listEl = doc.querySelector('[data-attribute="list-item"]');
    if (listEl) {
      result.list.colPerView = Number(listEl.getAttribute('data-col-per-view')) || result.list.colPerView;
      result.list.spaceBetween = Number(listEl.getAttribute('data-space-between')) || result.list.spaceBetween;
    }

    const itemEls = doc.querySelectorAll('[data-attribute="list-item"] [data-attribute="item"]');
    itemEls.forEach(itemEl => {
      const imgEl = itemEl.querySelector('[data-attribute="image-item"]');
      const nameEl = itemEl.querySelector('[data-attribute="product-name"]');
      const fromEl = itemEl.querySelector('[data-attribute="from-text"]');
      const priceNewEl = itemEl.querySelector('[data-attribute="price-new"]');
      const priceOldEl = itemEl.querySelector('[data-attribute="price-old"]');
      const stateEl = itemEl.querySelector('[data-attribute="state-product"]');
      const iconWrapEl = itemEl.querySelector('[data-attribute="icon-with-text"]');
      const iconEl = itemEl.querySelector('[data-attribute="icon-item"]');
      const iconTextEl = itemEl.querySelector('[data-attribute="text-item"]');
      const linkEl = itemEl.getAttribute('href');

      result.list.items.push({
        image: imgEl?.getAttribute('src') || '',
        name: nameEl ? nameEl.innerHTML.trim() : '',
        fromText: fromEl ? fromEl.innerHTML.trim() : '',
        priceNew: priceNewEl ? priceNewEl.innerHTML.trim() : '',
        priceOld: priceOldEl ? priceOldEl.innerHTML.trim() : '',
        stateProduct: stateEl ? stateEl.innerHTML.trim() : '',
        icon: iconEl?.getAttribute('src') || '',
        iconText: iconTextEl ? iconTextEl.innerHTML.trim() : '',
        showIconText: iconWrapEl ? iconWrapEl.getAttribute('data-show') !== 'false' : true,
        link: linkEl || '#',
      });
    });

    if (!result.list.items.length) {
      result.list.items.push({
        image: '',
        name: '<h3>Product name</h3><p>Short description.</p>',
        fromText: 'From',
        priceNew: '$0.00',
        priceOld: '',
        stateProduct: '',
        icon: '',
        iconText: '<p>Up to 300 ml</p>',
        showIconText: true,
      });
    }

    const buttonOutSideEl = doc.querySelector('[data-attribute="wrap-btn-dynamic-primary"]');
    if (buttonOutSideEl) {
      result.buttonOutSide = extractButtonBasic(buttonOutSideEl.outerHTML);
    }

    return result;
  },
  sectionImageWithTextConvenFeet01(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const defaultTitleContent =
      "<h2>OUR STORY</h2><p>As a physical therapist of 14 years, I've seen too many patients walk into my clinic defeated by chronic pain...</p><p>After treating over 1,200 patients, I noticed one devastating pattern: they were spending hundreds of dollars on 'high-end' sneakers and rigid orthotics, only for pain.</p>";
    const defaultImages = [
      {
        image: 'https://cdn.skyfastimg.com/6a0ee559dc2c2e000934dd37/2026/06/22/image-6a38f349b0c7b0911a3ce8ed.png',
      },
      {
        image: 'https://cdn.skyfastimg.com/6a0ee559dc2c2e000934dd37/2026/06/22/image-6a38f36464265353a3df3e77.png',
      },
      {
        image: 'https://cdn.skyfastimg.com/6a0ee559dc2c2e000934dd37/2026/06/22/image-6a38f381e4eab8147a94683b.png',
      },
    ];
    const result = {
      ...containerFuild,
      title:
        containerFuild.title === 'Freestyle Section' ? 'Image With Text Conven Feet 01 Section' : containerFuild.title,
      layout: {
        centerY: true,
        gapItem: 112,
        contentOrder: 1,
        borderImage: 10,
        borderColorImage: '#006196',
      },
      titleContent: defaultTitleContent,
      button: {},
      signature: {
        show: true,
        image: 'https://cdn.skyfastimg.com/6a0ee559dc2c2e000934dd37/2026/06/22/image-6a38f4dc1414e7524f4fcd9a.png',
      },
      images: [...defaultImages],
    };

    const wrapCard = doc.querySelector('[data-attribute="wrap-card"]');
    if (wrapCard) {
      result.layout.centerY = wrapCard.getAttribute('data-center-y') !== 'false';
      const gapItem = Number(wrapCard.getAttribute('data-gap-item'));
      result.layout.gapItem = Number.isFinite(gapItem) ? gapItem : result.layout.gapItem;
    }

    const wrapContent = doc.querySelector('[data-attribute="wrap-content"]');
    if (wrapContent) {
      const order = Number(wrapContent.getAttribute('data-order'));
      result.layout.contentOrder = order === 2 ? 2 : 1;
    }

    const wrapImages = doc.querySelector('[data-attribute="wrap-images"]');
    if (wrapImages) {
      const borderImage = Number(wrapImages.getAttribute('data-border-image'));
      result.layout.borderImage = Number.isFinite(borderImage) ? borderImage : result.layout.borderImage;
      result.layout.borderColorImage =
        wrapImages.getAttribute('data-border-color-image') || result.layout.borderColorImage;
    }

    const wrapTitle = doc.querySelector('[data-attribute="wrap-title"]');
    if (wrapTitle) {
      result.titleContent = wrapTitle.innerHTML.trim() || result.titleContent;
    }

    const btnEl = doc.querySelector('[data-attribute="wrap-btn-cta"]');
    if (btnEl) {
      result.button = extractButtonBasic(btnEl.outerHTML);
    }

    const signatureEl = doc.querySelector('[data-attribute="signature-image"]');
    if (signatureEl) {
      result.signature.show = signatureEl.getAttribute('data-show') !== 'false';
      result.signature.image = signatureEl.querySelector('img')?.getAttribute('src') || result.signature.image;
    }

    const blockImages = doc.querySelector('[data-attribute="block-images"]');
    if (blockImages) {
      result.images = [];
      blockImages.querySelectorAll('[data-attribute="image-item"]').forEach(img => {
        result.images.push({ image: img.getAttribute('src') || '' });
      });
    }
    if (!result.images.length) {
      result.images = [...defaultImages];
    }
    result.images = result.images.slice(0, 3);

    return result;
  },
  sectionImageWithTextConvenFeet02(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const defaultPolicyIcon =
      'https://cdn.skyfastimg.com/6a0ee559dc2c2e000934dd37/2026/06/23/image-6a3a31ba055ca064b1125668.png';
    const defaultMediaImage =
      'https://cdn.skyfastimg.com/6a0ee559dc2c2e000934dd37/2026/06/23/image-6a3a2f8c7fecf41de2c93be4.png';
    const result = {
      ...containerFuild,
      title:
        containerFuild.title === 'Freestyle Section' ? 'Image With Text Conven Feet 02 Section' : containerFuild.title,
      layout: {
        centerY: true,
        gapItem: 60,
        contentOrder: 1,
      },
      rateCard: {
        show: true,
        stars: 4,
        text: '14,000+ Happy Customers',
      },
      titleBlock: {
        show: true,
        content: "<h2>You'll Feel the Difference Instantly!</h2>",
      },
      policyItems: {
        show: true,
        color: '#006196',
        background: '#F2F7F9',
        items: [
          { icon: defaultPolicyIcon, text: 'Try Risk Free | 30-Day Wear Test Guarantee' },
          { icon: defaultPolicyIcon, text: 'Try Risk Free | 30-Day Wear Test Guarantee' },
        ],
      },
      description: {
        show: true,
        content:
          "<p>Our orthopedic shoes are lightweight, comfy, and built for all-day support. With great cushioning and slip-resistant soles, they're perfect for long shifts on any surface.</p><p>Whether you're in healthcare, retail, or hospitality, they'll keep your feet, legs, and back feeling good all day.</p>",
      },
      button: {},
      media: {
        image: defaultMediaImage,
      },
    };

    const wrapCard = doc.querySelector('[data-attribute="wrap-card"]');
    if (wrapCard) {
      result.layout.centerY = wrapCard.getAttribute('data-center-y') !== 'false';
      const gapItem = Number(wrapCard.getAttribute('data-gap-item'));
      result.layout.gapItem = Number.isFinite(gapItem) ? gapItem : result.layout.gapItem;
    }

    const wrapContent = doc.querySelector('[data-attribute="wrap-content"]');
    if (wrapContent) {
      const order = Number(wrapContent.getAttribute('data-order'));
      result.layout.contentOrder = order === 2 ? 2 : 1;
    }

    const rateCardEl = doc.querySelector('[data-attribute="wrap-rate-card"]');
    if (rateCardEl) {
      result.rateCard.show = rateCardEl.getAttribute('data-show') !== 'false';
      const starsEl = rateCardEl.querySelector('[data-attribute="wrap-stars"]');
      const stars = Number(starsEl?.getAttribute('data-value'));
      result.rateCard.stars = Number.isFinite(stars) ? stars : result.rateCard.stars;
      const ratingTextEl = rateCardEl.querySelector('[data-attribute="wrap-rating-text"]');
      result.rateCard.text = ratingTextEl?.textContent.trim() || result.rateCard.text;
    }

    const titleEl = doc.querySelector('[data-attribute="wrap-title"]');
    if (titleEl) {
      result.titleBlock.show = titleEl.getAttribute('data-show') !== 'false';
      result.titleBlock.content = titleEl.innerHTML.trim() || result.titleBlock.content;
    }

    const policyEl = doc.querySelector('[data-attribute="policy-items"]');
    if (policyEl) {
      result.policyItems.show = policyEl.getAttribute('data-show') !== 'false';
      result.policyItems.color = policyEl.getAttribute('data-color-policy-item') || result.policyItems.color;
      result.policyItems.background =
        policyEl.getAttribute('data-background-policy-item') || result.policyItems.background;
      result.policyItems.items = [];
      policyEl.querySelectorAll('[data-attribute="policy-item-content"]').forEach(itemEl => {
        result.policyItems.items.push({
          icon: itemEl.querySelector('[data-attribute="icon-image"]')?.getAttribute('src') || '',
          text: itemEl.querySelector('[data-attribute="policy-text"]')?.textContent.trim() || '',
        });
      });
    }
    if (!result.policyItems.items.length) {
      result.policyItems.items.push({ icon: defaultPolicyIcon, text: 'Try Risk Free | 30-Day Wear Test Guarantee' });
    }

    const descriptionEl = doc.querySelector('[data-attribute="description-card"]');
    if (descriptionEl) {
      result.description.show = descriptionEl.getAttribute('data-show') !== 'false';
      result.description.content = descriptionEl.innerHTML.trim() || result.description.content;
    }

    const btnEl = doc.querySelector('[data-attribute="wrap-btn-cta"]');
    if (btnEl) {
      result.button = extractButtonBasic(btnEl.outerHTML);
    }

    const wrapImageEl = doc.querySelector('[data-attribute="wrap-image"]');
    if (wrapImageEl) {
      result.media.image =
        wrapImageEl.querySelector('[data-attribute="image-item"]')?.getAttribute('src') || result.media.image;
    }

    return result;
  },
  sectionImageWithTextConvenFeet03(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const defaultIcon =
      'https://cdn.skyfastimg.com/6a0ee559dc2c2e000934dd37/2026/06/23/image-6a3a4d3cf9049a2d8658864f.png';
    const defaultMediaImage =
      'https://cdn.skyfastimg.com/6a0ee559dc2c2e000934dd37/2026/06/23/image-6a3a4dddb375ec169af0d930.png';
    const defaultItemContent =
      '<h3>Total Foot Relief</h3><p>Aching feet slowing you down? <br>Our expert-designed cushioning for cloud-like comfort that lasts all day will help!</p>';
    const result = {
      ...containerFuild,
      title:
        containerFuild.title === 'Freestyle Section' ? 'Image With Text Conven Feet 03 Section' : containerFuild.title,
      layout: {
        centerY: true,
        gapItem: 60,
        contentOrder: 1,
        backgroundContent: '#F2F7F9',
      },
      titleBlock: {
        show: true,
        content:
          '<h2>Proven To Increase Comfort & Mobility</h2><p>Stop letting foot pain dictate your day. Our orthopedic design targets the root cause of discomfort, giving you the freedom to move with zero pain.</p>',
      },
      iconItems: [
        { icon: defaultIcon, content: defaultItemContent },
        { icon: defaultIcon, content: defaultItemContent },
        { icon: defaultIcon, content: defaultItemContent },
      ],
      media: {
        image: defaultMediaImage,
      },
    };

    const wrapCard = doc.querySelector('[data-attribute="wrap-card"]');
    if (wrapCard) {
      result.layout.centerY = wrapCard.getAttribute('data-center-y') !== 'false';
      const gapItem = Number(wrapCard.getAttribute('data-gap-item'));
      result.layout.gapItem = Number.isFinite(gapItem) ? gapItem : result.layout.gapItem;
    }

    const wrapContent = doc.querySelector('[data-attribute="wrap-content"]');
    if (wrapContent) {
      const order = Number(wrapContent.getAttribute('data-order'));
      result.layout.contentOrder = order === 2 ? 2 : 1;
      result.layout.backgroundContent =
        wrapContent.getAttribute('data-background-content') || result.layout.backgroundContent;
    }

    const titleEl = doc.querySelector('[data-attribute="wrap-title"]');
    if (titleEl) {
      result.titleBlock.show = titleEl.getAttribute('data-show') !== 'false';
      result.titleBlock.content = titleEl.innerHTML.trim() || result.titleBlock.content;
    }

    const blockIconEl = doc.querySelector('[data-attribute="block-icon-with-text"]');
    if (blockIconEl) {
      result.iconItems = [];
      blockIconEl.querySelectorAll('[data-attribute="item-icon-with-text"]').forEach(itemEl => {
        result.iconItems.push({
          icon: itemEl.querySelector('[data-attribute="icon-item"]')?.getAttribute('src') || '',
          content: itemEl.querySelector('[data-attribute="wrap-text"]')?.innerHTML.trim() || '',
        });
      });
    }
    if (!result.iconItems.length) {
      result.iconItems.push({ icon: defaultIcon, content: defaultItemContent });
    }

    const wrapImageEl = doc.querySelector('[data-attribute="wrap-image"]');
    if (wrapImageEl) {
      result.media.image =
        wrapImageEl.querySelector('[data-attribute="image-item"]')?.getAttribute('src') || result.media.image;
    }

    return result;
  },
  sectionIconGridWithHeroTextConvenFeet(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const defaultItemImage =
      'https://cdn.skyfastimg.com/6a0ee559dc2c2e000934dd37/2026/06/23/image-6a39f221293fc4c9d3a3e40a.png';
    const defaultItemContent =
      '<h3>Plantar Fasciitis</h3><p>Sharp heel pain caused by micro-tears from poor arch support.</p>';
    const result = {
      ...containerFuild,
      title:
        containerFuild.title === 'Freestyle Section'
          ? 'Icon Grid With Hero Text Conven Feet Section'
          : containerFuild.title,
      cardTitle: {
        content:
          '<h2 style="text-align: center;">Why Your Feet Are Screaming For Help?</h2><p style="text-align: center;">75% of adults will experience debilitating foot pain at some point. It\'s not just "getting old"</p><p style="text-align: center;">It\'s a sign that your foundation is collapsing!!!</p><p style="text-align: center;">you recognize any of these symptoms, your current footwear is likely causing permanent damage.</p>',
      },
      listItem: {
        colPerView: 4,
        bgColorItem: '#006196',
        borderColorItem: '#006196',
      },
      items: [],
    };

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.content = cardTitleEl.innerHTML.trim() || result.cardTitle.content;
    }

    const listItemEl = doc.querySelector('[data-attribute="list-item"]');
    if (listItemEl) {
      const colPerView = Number(listItemEl.getAttribute('data-col-perview'));
      result.listItem.colPerView =
        Number.isFinite(colPerView) && colPerView > 0 ? colPerView : result.listItem.colPerView;
      result.listItem.bgColorItem = listItemEl.getAttribute('data-bg-color-item') || result.listItem.bgColorItem;
      result.listItem.borderColorItem =
        listItemEl.getAttribute('data-border-color-item') || result.listItem.borderColorItem;
    }

    const itemEls = listItemEl ? listItemEl.querySelectorAll('[data-attribute="icon-twc"]') : [];
    itemEls.forEach(elItem => {
      result.items.push({
        image: elItem.querySelector('[data-attribute="image-item"]')?.getAttribute('src') || '',
        content: elItem.querySelector('[data-attribute="content-item"]')?.innerHTML.trim() || '',
      });
    });

    if (!result.items.length) {
      result.items.push({ image: defaultItemImage, content: defaultItemContent });
    }

    return result;
  },
  sectionCalyrafitBanner(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerFuild,
      title: containerFuild.title === 'Freestyle Section' ? 'Calyrafit Banner Section' : containerFuild.title,
      media: {
        useVideo: true,
        videoSrc: '',
        image: '',
      },
      highlights: {
        show: true,
        colPerView: 4,
        items: [],
      },
    };

    const wrapMedia = doc.querySelector('[data-attribute="wrap-media"]');
    if (wrapMedia) {
      result.media.useVideo = wrapMedia.getAttribute('data-use-vid') !== 'false';
    }

    const videoEl = doc.querySelector('[data-attribute="video-banner"]');
    if (videoEl) {
      result.media.videoSrc = videoEl.getAttribute('src') || '';
    }

    const imageEl = doc.querySelector('[data-attribute="image-banner"]');
    if (imageEl) {
      result.media.image = imageEl.getAttribute('src') || '';
    }

    const wrapHighlights = doc.querySelector('[data-attribute="wrap-highlights"]');
    if (wrapHighlights) {
      result.highlights.show = wrapHighlights.getAttribute('data-show') !== 'false';
      const colPerView = Number(wrapHighlights.getAttribute('col-per-view'));
      result.highlights.colPerView =
        Number.isFinite(colPerView) && colPerView > 0 ? colPerView : result.highlights.colPerView;

      wrapHighlights.querySelectorAll('[data-attribute="item-highlight"]').forEach(item => {
        result.highlights.items.push({
          content: item.innerHTML.trim() || '',
        });
      });
    }

    if (!result.highlights.items.length) {
      result.highlights.items.push({ content: '<h3>200k+</h3><p>5 Star Reviews</p>' });
    }

    return result;
  },
  sectionCalyrafitMarquee01(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerFuild,
      title: containerFuild.title === 'Freestyle Section' ? 'Calyrafit Marquee 01 Section' : containerFuild.title,
      speed: 25,
      items: [],
    };

    const blockMarquee = doc.querySelector('[data-attribute="block-marquee"]');
    if (blockMarquee) {
      const speed = Number(blockMarquee.getAttribute('data-speed'));
      result.speed = Number.isFinite(speed) && speed > 0 ? speed : result.speed;
    }

    const listItem = doc.querySelector('[data-attribute="list-item"]');
    if (listItem) {
      listItem.querySelectorAll('[data-attribute="item"]').forEach(item => {
        const linkEl = item.querySelector('[data-attribute="link-item"]');
        const imageEl = item.querySelector('[data-attribute="image-item"]');
        result.items.push({
          image: imageEl?.getAttribute('src') || '',
          link: linkEl?.getAttribute('href') || '#',
        });
      });
    }

    if (!result.items.length) {
      result.items.push({ image: '', link: '#' });
    }

    return result;
  },
  sectionCalyrafitMarquee(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerFuild,
      title: containerFuild.title === 'Freestyle Section' ? 'Calyrafit Marquee Section' : containerFuild.title,
      cardTitle: {
        show: true,
        content:
          '<h2 style="text-align: center;">Over 565K+ Happy Customers</h2><p style="text-align: center;">Designed to shape, support, and move with your body-helping women feel more confident, comfortable, and empowered every day.</p>',
      },
      speed: 25,
      itemGap: 30,
      itemWidth: 270,
      items: [],
    };

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim() || result.cardTitle.content;
    }

    const blockMarquee = doc.querySelector('[data-attribute="block-marquee"]');
    if (blockMarquee) {
      const speed = Number(blockMarquee.getAttribute('data-speed'));
      result.speed = Number.isFinite(speed) && speed > 0 ? speed : result.speed;

      const itemGap = Number(blockMarquee.getAttribute('data-item-gap'));
      result.itemGap = Number.isFinite(itemGap) && itemGap >= 0 ? itemGap : result.itemGap;

      const itemWidth = Number(blockMarquee.getAttribute('data-item-width'));
      result.itemWidth = Number.isFinite(itemWidth) && itemWidth > 0 ? itemWidth : result.itemWidth;
    }

    const listItem = doc.querySelector('[data-attribute="list-item"]');
    if (listItem) {
      listItem.querySelectorAll('[data-attribute="item"]').forEach(item => {
        const imageEl = item.querySelector('[data-attribute="image-item"]');
        result.items.push({
          image: imageEl?.getAttribute('src') || '',
        });
      });
    }

    if (!result.items.length) {
      result.items.push({ image: '' });
    }

    return result;
  },
  sectionCalyrafitGirdImage(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerFuild,
      title: containerFuild.title === 'Freestyle Section' ? 'Calyrafit Grid Image Section' : containerFuild.title,
      mainImage: {
        image: '',
        link: '#',
      },
      // Danh sách cố định số lượng (không add/remove được từ editor)
      secondImages: [],
    };

    const wrapMainImage = doc.querySelector('[data-attribute="wrap-main-image"]');
    if (wrapMainImage) {
      result.mainImage.link = wrapMainImage.getAttribute('href') || '#';
    }

    const imageMainEl = doc.querySelector('[data-attribute="image-main"]');
    if (imageMainEl) {
      result.mainImage.image = imageMainEl.getAttribute('src') || '';
    }

    const groupImgSecond = doc.querySelector('[data-attribute="group-img-second"]');
    if (groupImgSecond) {
      groupImgSecond.querySelectorAll('[data-attribute="wrap-img-item"]').forEach(item => {
        const imageEl = item.querySelector('[data-attribute="image-second"]');
        result.secondImages.push({
          image: imageEl?.getAttribute('src') || '',
          link: item.getAttribute('href') || '',
        });
      });
    }

    if (!result.secondImages.length) {
      result.secondImages = [
        { image: '', link: '' },
        { image: '', link: '' },
      ];
    }

    return result;
  },
  sectionCalyrafitBestSaller(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerFuild,
      title: containerFuild.title === 'Freestyle Section' ? 'Calyrafit Best Seller Section' : containerFuild.title,
      cardTitle: {
        show: true,
        content: '<h2>BEST SELLER</h2><p>Lorem ipsum dolor sit amet consectetur,</p>',
      },
      highlightColor: '#AD4870',
      // Nguồn dữ liệu DUY NHẤT cho sản phẩm - chỉ đọc từ khối desktop (chung data với mobile).
      products: [],
      buttonOutSide: {},
    };

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim() || result.cardTitle.content;
    }

    const bodyProductsEl = doc.querySelector('[data-attribute="body-products"]');
    if (bodyProductsEl) {
      result.highlightColor = bodyProductsEl.getAttribute('data-highlight-color') || result.highlightColor;
    }

    const desktopEl = doc.querySelector('[data-attribute="gird-products-desktop"]');
    const itemEls = desktopEl ? desktopEl.querySelectorAll('[data-attribute="item-product"]') : [];
    itemEls.forEach(itemEl => {
      const wrapImagesEl = itemEl.querySelector('[data-attribute="wrap-images"]');
      const imageEls = wrapImagesEl ? wrapImagesEl.querySelectorAll('[data-attribute="item-image"]') : [];
      const stateEl = itemEl.querySelector('[data-attribute="state"]');
      const titleEl = itemEl.querySelector('[data-attribute="title-item"]');
      const priceEl = itemEl.querySelector('[data-attribute="price"]');
      const oldPriceEl = itemEl.querySelector('[data-attribute="old-price"]');

      result.products.push({
        link: itemEl.getAttribute('href') || '#',
        images: Array.from(imageEls).map(imageEl => imageEl.getAttribute('src') || ''),
        state: {
          show: stateEl ? stateEl.getAttribute('data-show') !== 'false' : true,
          text: stateEl ? stateEl.innerHTML.trim() : '',
        },
        title: titleEl ? titleEl.innerHTML.trim() : '',
        price: priceEl ? priceEl.innerHTML.trim() : '',
        oldPrice: oldPriceEl ? oldPriceEl.innerHTML.trim() : '',
      });
    });

    if (!result.products.length) {
      result.products.push({
        link: '#',
        images: [''],
        state: { show: true, text: 'New' },
        title: '<h3>Product name</h3>',
        price: '$0.00',
        oldPrice: '',
      });
    }

    const buttonOutSideEl = doc.querySelector('[data-attribute="wrap-btn-dynamic-primary"]');
    if (buttonOutSideEl) {
      result.buttonOutSide = extractButtonBasic(buttonOutSideEl.outerHTML);
    }

    return result;
  },
  sectionCalyrafitSideBySide(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const defaultStatsItems = [
      { content: '<h3>47+</h3><p>Pressure <br />points</p>' },
      { content: '<h3>8h</h3><p>Passive <br />treatment</p>' },
      { content: '<h3>30%</h3><p>Circulation <br />boost</p>' },
    ];
    const defaultPillItems = [
      { text: 'Shape your waist' },
      { text: 'Support your curves' },
      { text: 'Move with confidence' },
    ];
    const result = {
      ...containerFuild,
      title: containerFuild.title === 'Freestyle Section' ? 'Calyrafit Side By Side Section' : containerFuild.title,
      media: {
        useVideo: true,
        videoSrc: '',
        image: '',
        order: 1,
        useCustomWidth: true,
        customWidth: 585,
      },
      content: {
        order: 2,
        bgColor: '#FFD0DB',
      },
      heading: {
        show: true,
        content: '<h2>Define Your Contour - Own Your Contour.</h2><p></p>',
      },
      stats: {
        show: true,
        bgColor: '#ffffff',
        borderColor: '#FFD0DB',
        items: [...defaultStatsItems],
      },
      pills: {
        show: true,
        bgColor: '#ffffff',
        borderColor: '#FFD0DB',
        items: [...defaultPillItems],
      },
      featureCallout: {
        show: true,
        colorLine: '#AD4870',
        content: '<h3>The right pressure. In the right places.</h3><p></p>',
      },
      testimonial: {
        show: true,
        colorHighlight: '#FFD0DB',
        avatar: '',
        content: '<h4></h4><p></p>',
      },
      button: {},
    };

    const leftCardEl = doc.querySelector('[data-attribute="left-card"]');
    if (leftCardEl) {
      const order = Number(leftCardEl.getAttribute('data-order'));
      result.media.order = order === 2 ? 2 : 1;
      result.media.useCustomWidth = leftCardEl.getAttribute('data-use-custom-width') !== 'false';
      const customWidth = Number(leftCardEl.getAttribute('data-custom-width'));
      result.media.customWidth =
        Number.isFinite(customWidth) && customWidth > 0 ? customWidth : result.media.customWidth;
      result.media.useVideo = leftCardEl.getAttribute('data-use-vid') !== 'false';
    }

    const videoEl = doc.querySelector('[data-attribute="video-left"]');
    if (videoEl) {
      result.media.videoSrc = videoEl.getAttribute('src') || '';
    }

    const imageEl = doc.querySelector('[data-attribute="img-left"]');
    if (imageEl) {
      result.media.image = imageEl.getAttribute('src') || '';
    }

    const rightCardEl = doc.querySelector('[data-attribute="right-card"]');
    if (rightCardEl) {
      const order = Number(rightCardEl.getAttribute('data-order'));
      result.content.order = order === 1 ? 1 : 2;
      result.content.bgColor = rightCardEl.getAttribute('data-bg-content') || result.content.bgColor;
    }

    const headingEl = doc.querySelector('[data-attribute="heading-content"]');
    if (headingEl) {
      result.heading.show = headingEl.getAttribute('data-show') !== 'false';
      result.heading.content = headingEl.innerHTML.trim() || result.heading.content;
    }

    const statsGroupEl = doc.querySelector('[data-attribute="stats-group"]');
    if (statsGroupEl) {
      result.stats.show = statsGroupEl.getAttribute('data-show') !== 'false';
      result.stats.bgColor = statsGroupEl.getAttribute('data-bg-stats-group') || result.stats.bgColor;
      result.stats.borderColor = statsGroupEl.getAttribute('data-color-border') || result.stats.borderColor;

      result.stats.items = [];
      statsGroupEl.querySelectorAll('[data-attribute="stats-group-item"]').forEach(item => {
        result.stats.items.push({ content: item.innerHTML.trim() || '' });
      });
      if (!result.stats.items.length) {
        result.stats.items = [...defaultStatsItems];
      }
    }

    const listPillEl = doc.querySelector('[data-attribute="list-pill"]');
    if (listPillEl) {
      result.pills.show = listPillEl.getAttribute('data-show') !== 'false';
      result.pills.bgColor = listPillEl.getAttribute('data-bg-pill') || result.pills.bgColor;
      result.pills.borderColor = listPillEl.getAttribute('data-color-border') || result.pills.borderColor;

      result.pills.items = [];
      listPillEl.querySelectorAll('[data-attribute="pill-item"]').forEach(item => {
        result.pills.items.push({ text: item.textContent.trim() || '' });
      });
      if (!result.pills.items.length) {
        result.pills.items = [...defaultPillItems];
      }
    }

    const featureCalloutEl = doc.querySelector('[data-attribute="feature-callout"]');
    if (featureCalloutEl) {
      result.featureCallout.show = featureCalloutEl.getAttribute('data-show') !== 'false';
      result.featureCallout.colorLine =
        featureCalloutEl.getAttribute('data-color-line') || result.featureCallout.colorLine;
      result.featureCallout.content = featureCalloutEl.innerHTML.trim() || result.featureCallout.content;
    }

    const testimonialEl = doc.querySelector('[data-attribute="testimonial"]');
    if (testimonialEl) {
      result.testimonial.show = testimonialEl.getAttribute('data-show') !== 'false';
      result.testimonial.colorHighlight =
        testimonialEl.getAttribute('data-color-highlight') || result.testimonial.colorHighlight;
    }

    const avatarEl = doc.querySelector('[data-attribute="avatar-expert"]');
    if (avatarEl) {
      result.testimonial.avatar = avatarEl.getAttribute('src') || '';
    }

    const testimonialContentEl = doc.querySelector('[data-attribute="testimonial-content"]');
    if (testimonialContentEl) {
      result.testimonial.content = testimonialContentEl.innerHTML.trim() || result.testimonial.content;
    }

    const btnEl = doc.querySelector('[data-attribute="wrap-btn-dynamic"]');
    if (btnEl) {
      result.button = extractButtonBasic(btnEl.outerHTML);
    }

    return result;
  },
  sectionCalyrafitSlide(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const defaultItems = [
      {
        image: '',
        subTitle: '',
        title: '',
        cta: { link: '#', text: 'Shop Now', icon: '' },
      },
    ];
    const result = {
      ...containerFuild,
      title: containerFuild.title === 'Freestyle Section' ? 'Calyrafit Slide Section' : containerFuild.title,
      cardTitle: {
        show: true,
        content: "<h2>Don't just take our word for it</h2><p></p>",
      },
      items: [],
    };

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim() || result.cardTitle.content;
    }

    const itemEls = doc.querySelectorAll('[data-attribute="slide-item"]');
    itemEls.forEach(itemEl => {
      const imageEl = itemEl.querySelector('[data-attribute="item-image"]');
      const subTitleEl = itemEl.querySelector('[data-attribute="sub-title-item"]');
      const titleEl = itemEl.querySelector('[data-attribute="title-item"]');
      const ctaEl = itemEl.querySelector('[data-attribute="cta-item"]');
      const textCtaEl = itemEl.querySelector('[data-attribute="text-cta"]');
      const iconCtaEl = itemEl.querySelector('[data-attribute="icon-cta"]');

      result.items.push({
        image: imageEl ? imageEl.getAttribute('src') || '' : '',
        // Dùng textContent thay vì innerHTML: đây là plain-text field (v-text-field), innerHTML sẽ
        // escape "&" -> "&amp;" khi serialize DOM, làm chuỗi hiển thị sai trong input.
        subTitle: subTitleEl ? subTitleEl.textContent.trim() : '',
        title: titleEl ? titleEl.textContent.trim() : '',
        cta: {
          link: ctaEl ? ctaEl.getAttribute('href') || '#' : '#',
          text: textCtaEl ? textCtaEl.textContent.trim() : '',
          icon: iconCtaEl ? iconCtaEl.getAttribute('src') || '' : '',
        },
      });
    });

    if (!result.items.length) {
      result.items = defaultItems;
    }

    return result;
  },
  sectionCalyrafitCollections(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const defaultItems = [
      {
        link: '#',
        image: '',
        content: '<h3>30% Push-Up Effect</h3><p>30% Push-Up Effect</p>',
      },
    ];
    const result = {
      ...containerFuild,
      title: containerFuild.title === 'Freestyle Section' ? 'Calyrafit Collections Section' : containerFuild.title,
      cardTitle: {
        show: true,
        content:
          '<h2>Why Women Choose <span style="color:#ad4870;"><i>CalyraFit™</i></span></h2><p>Designed to smooth, sculpt, and support your body with every move, so you can feel more confident from the moment you put them on.</p>',
      },
      items: [],
      button: {},
    };

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim() || result.cardTitle.content;
    }

    const itemEls = doc.querySelectorAll('[data-attribute="item"]');
    itemEls.forEach(itemEl => {
      const imageEl = itemEl.querySelector('[data-attribute="image-item"]');
      const contentEl = itemEl.querySelector('[data-attribute="title"]');
      result.items.push({
        link: itemEl.getAttribute('href') || '#',
        image: imageEl ? imageEl.getAttribute('src') || '' : '',
        content: contentEl ? contentEl.innerHTML.trim() : '',
      });
    });

    if (!result.items.length) {
      result.items = defaultItems;
    }

    const btnEl = doc.querySelector('[data-attribute="wrap-btn-dynamic-primary"]');
    if (btnEl) {
      result.button = extractButtonBasic(btnEl.outerHTML);
    }

    return result;
  },
  sectionCalyrafitTextWithIcon(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const defaultItems = [
      { icon: '', content: '<p>Worldwide Shipping</p>' },
      { icon: '', content: '<p>Worldwide Shipping</p>' },
      { icon: '', content: '<p>Worldwide Shipping</p>' },
      { icon: '', content: '<p>Worldwide Shipping</p>' },
    ];
    const result = {
      ...containerFuild,
      title: containerFuild.title === 'Freestyle Section' ? 'Calyrafit Text With Icon Section' : containerFuild.title,
      bgWrapper: '#FCF8F9',
      colorDevider: '#FFD0DB',
      items: [],
    };

    const listItemEl = doc.querySelector('[data-attribute="list-item"]');
    if (listItemEl) {
      result.bgWrapper = listItemEl.getAttribute('data-bg-wrapper') || result.bgWrapper;
      result.colorDevider = listItemEl.getAttribute('data-color-devider') || result.colorDevider;

      listItemEl.querySelectorAll('[data-attribute="item-text-with-icon"]').forEach(itemEl => {
        const iconEl = itemEl.querySelector('[data-attribute="icon-item"]');
        const textEl = itemEl.querySelector('[data-attribute="text-item"]');
        result.items.push({
          icon: iconEl ? iconEl.getAttribute('src') || '' : '',
          content: textEl ? textEl.innerHTML.trim() : '',
        });
      });
    }

    if (!result.items.length) {
      result.items = defaultItems;
    }

    return result;
  },
  sectionCalyrafitReview(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);

    const buildDefaultItem = () => ({
      stars: 5,
      content:
        "<h4>Like A Workout In Disguise</h4><p>\"I was skeptical at first, but these leggings really do feel different. I can feel my legs working more when I'm walking, yet they're still comfortable enough to wear all day. It's become my favorite way to stay active.\"</p>",
      avatar: '',
      name: 'Customer',
      showVerified: true,
      verifiedIcon: '',
      verifiedText: 'Verified Buyer',
    });

    const result = {
      ...containerFuild,
      title: containerFuild.title === 'Freestyle Section' ? 'Calyrafit Review Section' : containerFuild.title,
      list: {
        colorStar: '#EF5A7B',
        colPerView: 3,
        spaceBetween: 24,
        items: [],
      },
    };

    const listEl = doc.querySelector('[data-attribute="list-review"]');
    if (listEl) {
      result.list.colorStar = listEl.getAttribute('data-color-star') || result.list.colorStar;
      result.list.colPerView = Number(listEl.getAttribute('data-col-per-view')) || result.list.colPerView;
      result.list.spaceBetween = Number(listEl.getAttribute('data-space-between')) || result.list.spaceBetween;
    }

    const itemEls = doc.querySelectorAll('[data-attribute="list-review"] [data-attribute="item-review"]');
    itemEls.forEach(itemEl => {
      const starsEl = itemEl.querySelector('[data-attribute="wrap-stars"]');
      const contentEl = itemEl.querySelector('[data-attribute="review-content"]');
      const avatarEl = itemEl.querySelector('[data-attribute="avatar-reviewer"]');
      const nameEl = itemEl.querySelector('[data-attribute="name-reviewer"]');
      const verifiedEl = itemEl.querySelector('[data-attribute="verified-buyer"]');
      const verifiedIconEl = itemEl.querySelector('[data-attribute="icon-verified"]');
      const verifiedTextEl = itemEl.querySelector('[data-attribute="text-verified"]');

      const starsValue = Number(starsEl?.getAttribute('data-star'));
      result.list.items.push({
        stars: Number.isFinite(starsValue) ? Math.max(0, Math.min(5, starsValue)) : 5,
        content: contentEl ? contentEl.innerHTML.trim() : '',
        avatar: avatarEl?.getAttribute('src') || '',
        name: nameEl ? nameEl.innerHTML.trim() : '',
        showVerified: verifiedEl ? verifiedEl.getAttribute('data-show') !== 'false' : true,
        verifiedIcon: verifiedIconEl?.getAttribute('src') || '',
        verifiedText: verifiedTextEl ? verifiedTextEl.innerHTML.trim() : 'Verified Buyer',
      });
    });

    if (!result.list.items.length) {
      result.list.items.push(buildDefaultItem());
    }

    return result;
  },
  sectionCalyrafitFooter(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerFuild,
      title: containerFuild.title === 'Freestyle Section' ? 'Calyrafit Footer Section' : containerFuild.title,
      logo: '',
      addressText: '',
      emailItems: [],
      socialItems: [],
      orderTitle: 'Order',
      orderItems: [],
      resourcesTitle: 'Resources',
      resourcesItems: [],
      subscribeTitle: 'Stay In The Know',
      inputPlaceholder: 'Enter Your Email...',
      inputColor: '#AD4870',
      submitIcon: '',
      descriptionSubscribe: '',
      bottomBgColor: '#AD4870',
      bottomTextColor: '#FFFFFF',
      copyrightText: '',
    };

    const logoEl = doc.querySelector('[data-attribute="logo-footer"]');
    if (logoEl) result.logo = logoEl.getAttribute('src') || result.logo;

    const addressEl = doc.querySelector('[data-attribute="address-store"]');
    if (addressEl) result.addressText = addressEl.textContent.trim() || result.addressText;

    doc.querySelectorAll('[data-attribute="item-company-info"]').forEach(itemEl => {
      result.emailItems.push({
        text: itemEl.textContent.trim(),
        link: itemEl.getAttribute('href') || '',
      });
    });
    if (!result.emailItems.length) {
      result.emailItems.push({ text: '📩 support@calyrafit.com', link: 'mailto:support@calyrafit.com' });
    }

    doc.querySelectorAll('[data-attribute="item-social"]').forEach(itemEl => {
      const iconEl = itemEl.querySelector('[data-attribute="icon-social"]');
      result.socialItems.push({
        link: itemEl.getAttribute('href') || '',
        icon: iconEl ? iconEl.getAttribute('src') || '' : '',
      });
    });
    if (!result.socialItems.length) {
      result.socialItems.push({ link: '', icon: '' });
    }

    const orderTitleEl = doc.querySelector('[data-attribute="title-column-order"]');
    if (orderTitleEl) result.orderTitle = orderTitleEl.textContent.trim() || result.orderTitle;

    doc.querySelectorAll('[data-attribute="item-order"]').forEach(itemEl => {
      result.orderItems.push({
        text: itemEl.textContent.trim(),
        link: itemEl.getAttribute('href') || '',
      });
    });
    if (!result.orderItems.length) {
      result.orderItems.push({ text: 'Contact Us', link: '' });
    }

    const resourcesTitleEl = doc.querySelector('[data-attribute="title-column-resources"]');
    if (resourcesTitleEl) result.resourcesTitle = resourcesTitleEl.textContent.trim() || result.resourcesTitle;

    doc.querySelectorAll('[data-attribute="item-resources"]').forEach(itemEl => {
      result.resourcesItems.push({
        text: itemEl.textContent.trim(),
        link: itemEl.getAttribute('href') || '',
      });
    });
    if (!result.resourcesItems.length) {
      result.resourcesItems.push({ text: 'About Us', link: '' });
    }

    const subscribeTitleEl = doc.querySelector('[data-attribute="title-column-subscribe"]');
    if (subscribeTitleEl) result.subscribeTitle = subscribeTitleEl.textContent.trim() || result.subscribeTitle;

    const inputEl = doc.querySelector('[data-attribute="input-email"]');
    if (inputEl) {
      result.inputPlaceholder = inputEl.getAttribute('placeholder') || result.inputPlaceholder;
      result.inputColor = inputEl.getAttribute('data-color-input') || result.inputColor;
    }

    const submitIconEl = doc.querySelector('[data-attribute="icon-submit-email"]');
    if (submitIconEl) result.submitIcon = submitIconEl.getAttribute('src') || result.submitIcon;

    const descriptionEl = doc.querySelector('[data-attribute="description-subscribe"]');
    if (descriptionEl) result.descriptionSubscribe = descriptionEl.textContent.trim() || result.descriptionSubscribe;

    const bottomFooterEl = doc.querySelector('[data-attribute="bottom-footer"]');
    if (bottomFooterEl) {
      result.bottomBgColor = bottomFooterEl.getAttribute('data-bg-bottom-footer') || result.bottomBgColor;
      result.bottomTextColor = bottomFooterEl.getAttribute('data-color-bottom-footer') || result.bottomTextColor;
    }

    const copyrightEl = doc.querySelector('[data-attribute="copyright"]');
    if (copyrightEl) result.copyrightText = copyrightEl.textContent.trim() || result.copyrightText;

    const paymentIconEl = doc.querySelector('[data-attribute="payment-icon"]');
    if (paymentIconEl) result.paymentIcon = paymentIconEl.getAttribute('src') || result.paymentIcon;

    return result;
  },
  sectionCeflorecoBanner1(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerFuild,
      title: containerFuild.title === 'Freestyle Section' ? 'Cefloreco Banner 1 Section' : containerFuild.title,
      content:
        '<p>Digital Product Studio</p><h2>Creativity brought to life</h2><p>We turn ideas into digital products, stories and experiences used worldwide.</p>',
      useBannerMobile: true,
      imageDesktop: 'https://cefloreco.com/images/bg-creativity.webp',
      imageMobile: 'https://cefloreco.com/images/bg-creativity-mb.webp',
    };

    const titleEl = doc.querySelector('[data-attribute="title-banner"]');
    if (titleEl) {
      result.content = titleEl.innerHTML.trim() || result.content;
    }

    const wrapImageEl = doc.querySelector('[data-attribute="wrap-banner-image"]');
    if (wrapImageEl) {
      result.useBannerMobile = wrapImageEl.getAttribute('data-use-banner-mobile') !== 'false';
    }

    const imageDesktopEl = doc.querySelector('[data-attribute="banner-image-desktop"]');
    if (imageDesktopEl) {
      result.imageDesktop = imageDesktopEl.getAttribute('src') ?? result.imageDesktop;
    }

    const imageMobileEl = doc.querySelector('[data-attribute="banner-image-mobile"]');
    if (imageMobileEl) {
      result.imageMobile = imageMobileEl.getAttribute('src') ?? result.imageMobile;
    }

    return result;
  },
  sectionCeflorecoProductWorld(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerFuild,
      title: containerFuild.title === 'Freestyle Section' ? 'Cefloreco Product World Section' : containerFuild.title,
      titleContent: '<p>Our product universe</p><h2>One studio.<br>Many everyday<br>experiences.</h2>',
      descContent: '<p>From entertainment and creativity to learning and utility, we build digital products.</p>',
      image: '',
      colorBorderItem: '#bebebe',
      colorHighlightItem: '#ff7657',
      items: [],
    };

    const titleEl = doc.querySelector('[data-attribute="title-card"]');
    if (titleEl) {
      result.titleContent = titleEl.innerHTML.trim() || result.titleContent;
    }

    const descEl = doc.querySelector('[data-attribute="desc-card"]');
    if (descEl) {
      result.descContent = descEl.innerHTML.trim() || result.descContent;
    }

    const imageEl = doc.querySelector('[data-attribute="img-preview-image"]');
    if (imageEl) {
      result.image = imageEl.getAttribute('src') ?? result.image;
    }

    const listEl = doc.querySelector('[data-attribute="list-fetures"]');
    if (listEl) {
      result.colorBorderItem = listEl.getAttribute('data-color-border-item') ?? result.colorBorderItem;
      result.colorHighlightItem = listEl.getAttribute('data-color-highlight-item') ?? result.colorHighlightItem;
      listEl.querySelectorAll('[data-attribute="item-freture"]').forEach(item => {
        const sttEl = item.querySelector('[data-attribute="stt-item"]');
        const contentEl = item.querySelector('[data-attribute="content-item"]');
        result.items.push({
          number: sttEl ? sttEl.textContent.trim() : '',
          content: contentEl ? contentEl.innerHTML.trim() : '',
        });
      });
    }

    return result;
  },
  sectionCeflorecoBanner2(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerFuild,
      title: containerFuild.title === 'Freestyle Section' ? 'Cefloreco Banner 2 Section' : containerFuild.title,
      titleContent: '<p>Our product universe</p><h2>One studio.<br>Many everyday<br>experiences.</h2>',
      descContent: '<p>From entertainment and creativity to learning and utility, we build digital products.</p>',
      image: '',
    };

    const titleEl = doc.querySelector('[data-attribute="title-card"]');
    if (titleEl) {
      result.titleContent = titleEl.innerHTML.trim() || result.titleContent;
    }

    const descEl = doc.querySelector('[data-attribute="desc-card"]');
    if (descEl) {
      result.descContent = descEl.innerHTML.trim() || result.descContent;
    }

    const imageEl = doc.querySelector('[data-attribute="banner-image"]');
    if (imageEl) {
      result.image = imageEl.getAttribute('src') ?? result.image;
    }

    return result;
  },
  sectionCeflorecoTextGradient(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerFuild,
      title: containerFuild.title === 'Freestyle Section' ? 'Cefloreco Text Gradient Section' : containerFuild.title,
      text: '130M+',
      fromColor: '#eeeeee',
      toColor: '#333333',
      description: 'Monthly Active Users',
    };

    const titleEl = doc.querySelector('[data-attribute="title-gradient"]');
    if (titleEl) {
      result.text = titleEl.textContent.trim() || result.text;
      result.fromColor = titleEl.getAttribute('data-from-color') ?? result.fromColor;
      result.toColor = titleEl.getAttribute('data-to-color') ?? result.toColor;
    }

    const descEl = doc.querySelector('[data-attribute="description"]');
    if (descEl) {
      result.description = descEl.textContent.trim() || result.description;
    }

    return result;
  },
  sectionCeflorecoSideBySide(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerFuild,
      title: containerFuild.title === 'Freestyle Section' ? 'Cefloreco Side By Side Section' : containerFuild.title,
      image: '',
      mediaPosition: 'left',
      content:
        '<p>Intelligence with a purpose</p><h2>Helpful by design.<br>Human at heart.</h2><p>We explore AI as a quiet layer of assistance.</p>',
    };

    const imageEl = doc.querySelector('[data-attribute="media-image"]');
    if (imageEl) {
      result.image = imageEl.getAttribute('src') ?? result.image;
    }

    const mediaEl = doc.querySelector('[data-attribute="media-content"]');
    const textEl = doc.querySelector('[data-attribute="text-content"]');
    if (mediaEl && textEl) {
      const orderMedia = Number(mediaEl.getAttribute('data-order-media')) || 1;
      const orderText = Number(textEl.getAttribute('data-order-text')) || 2;
      result.mediaPosition = orderMedia > orderText ? 'right' : 'left';
    }

    if (textEl) {
      result.content = textEl.innerHTML.trim() || result.content;
    }

    return result;
  },
  sectionCeflorecoMobileApp(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerFuild,
      title: containerFuild.title === 'Freestyle Section' ? 'Cefloreco Mobile App Section' : containerFuild.title,
      content:
        '<p>Made for every day</p><h2>Small screens.<br>Rich experiences.</h2><p>Clear, responsive and carefully paced.</p>',
      image: '',
    };

    const titleEl = doc.querySelector('[data-attribute="title-card"]');
    if (titleEl) {
      result.content = titleEl.innerHTML.trim() || result.content;
    }

    const imageEl = doc.querySelector('[data-attribute="image"]');
    if (imageEl) {
      result.image = imageEl.getAttribute('src') ?? result.image;
    }

    return result;
  },
  sectionCeflorecoBenefis(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerFuild,
      title: containerFuild.title === 'Freestyle Section' ? 'Cefloreco Benefis Section' : containerFuild.title,
      image: '',
      mediaTitle: '<p>IDEA TO</p><h3>IMPACT</h3>',
      bgMediaTitle: '#1099dc',
      mediaPosition: 'left',
      titleContent:
        '<p>What we do</p><h2>One team. Every part of the product.</h2><p>We move from insight to launch.</p>',
      colorHighlightItem: '#ff7657',
      items: [],
    };

    const mediaEl = doc.querySelector('[data-attribute="media-content"]');
    if (mediaEl) {
      result.bgMediaTitle = mediaEl.getAttribute('data-bg-media-title') ?? result.bgMediaTitle;
    }

    const imageEl = doc.querySelector('[data-attribute="media-image"]');
    if (imageEl) {
      result.image = imageEl.getAttribute('src') ?? result.image;
    }

    const mediaTitleEl = doc.querySelector('[data-attribute="media-title"]');
    if (mediaTitleEl) {
      result.mediaTitle = mediaTitleEl.innerHTML.trim() || result.mediaTitle;
    }

    const textEl = doc.querySelector('[data-attribute="text-content"]');
    if (mediaEl && textEl) {
      const orderMedia = Number(mediaEl.getAttribute('data-order-media')) || 1;
      const orderText = Number(textEl.getAttribute('data-order-text')) || 2;
      result.mediaPosition = orderMedia > orderText ? 'right' : 'left';
    }

    const titleEl = doc.querySelector('[data-attribute="title-content"]');
    if (titleEl) {
      result.titleContent = titleEl.innerHTML.trim() || result.titleContent;
    }

    const listEl = doc.querySelector('[data-attribute="list-benefit"]');
    if (listEl) {
      result.colorHighlightItem = listEl.getAttribute('data-color-highlight-item') ?? result.colorHighlightItem;
      listEl.querySelectorAll('[data-attribute="item-benefit"]').forEach(item => {
        const numberEl = item.querySelector('[data-attribute="index-number"]');
        const contentEl = item.querySelector('[data-attribute="content-benefit"]');
        result.items.push({
          number: numberEl ? numberEl.textContent.trim() : '',
          content: contentEl ? contentEl.innerHTML.trim() : '',
        });
      });
    }

    return result;
  },
  sectionCeflorecoLetsTalk(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerFuild,
      title: containerFuild.title === 'Freestyle Section' ? "Cefloreco Let's Talk Section" : containerFuild.title,
      titleContent: '<p>Our principles</p><h2>Simple on purpose.</h2>',
      colorBorderItem: '#bebebe',
      colorHighlightItem: '#ff7657',
      items: [],
      link: '#',
      useBannerMobile: true,
      imageDesktop: '',
      imageMobile: '',
    };

    const titleEl = doc.querySelector('[data-attribute="title-section"]');
    if (titleEl) {
      result.titleContent = titleEl.innerHTML.trim() || result.titleContent;
    }

    const listEl = doc.querySelector('[data-attribute="list-fetures"]');
    if (listEl) {
      result.colorBorderItem = listEl.getAttribute('data-color-border-item') ?? result.colorBorderItem;
      result.colorHighlightItem = listEl.getAttribute('data-color-highlight-item') ?? result.colorHighlightItem;
      listEl.querySelectorAll('[data-attribute="item-freture"]').forEach(item => {
        const sttEl = item.querySelector('[data-attribute="stt-item"]');
        const contentEl = item.querySelector('[data-attribute="content-item"]');
        result.items.push({
          number: sttEl ? sttEl.textContent.trim() : '',
          content: contentEl ? contentEl.innerHTML.trim() : '',
        });
      });
    }

    const bannerEl = doc.querySelector('[data-attribute="banner-image"]');
    if (bannerEl) {
      result.link = bannerEl.getAttribute('href') ?? result.link;
      result.useBannerMobile = bannerEl.getAttribute('data-use-banner-mobile') !== 'false';
    }

    const imageDesktopEl = doc.querySelector('[data-attribute="banner-desktop"]');
    if (imageDesktopEl) {
      result.imageDesktop = imageDesktopEl.getAttribute('src') ?? result.imageDesktop;
    }

    const imageMobileEl = doc.querySelector('[data-attribute="banner-mobile"]');
    if (imageMobileEl) {
      result.imageMobile = imageMobileEl.getAttribute('src') ?? result.imageMobile;
    }

    return result;
  },
  sectionCeflorecoFooter(htmlString) {
    const { result: containerFuild, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerFuild,
      title: containerFuild.title === 'Freestyle Section' ? 'Cefloreco Footer Section' : containerFuild.title,
      logo: '',
      description: 'Digital entertainment, beautifully made.',
      columns: [
        { key: 'product', title: 'Our product', items: [] },
        { key: 'company', title: 'Company Info', items: [] },
        { key: 'legal', title: 'Legal', items: [] },
      ],
      contactTitle: 'Contact',
      contactItems: [],
      copyright: '',
    };

    const logoEl = doc.querySelector('[data-attribute="logo-image"]');
    if (logoEl) {
      result.logo = logoEl.getAttribute('src') ?? result.logo;
    }

    const descEl = doc.querySelector('[data-attribute="desc-company"]');
    if (descEl) {
      result.description = descEl.textContent.trim() || result.description;
    }

    result.columns.forEach(column => {
      const titleEl = doc.querySelector(`[data-attribute="title-column-${column.key}"]`);
      if (titleEl) {
        column.title = titleEl.textContent.trim() || column.title;
      }
      const listEl = doc.querySelector(`[data-attribute="list-item-${column.key}"]`);
      if (listEl) {
        listEl.querySelectorAll('[data-attribute="item-child"]').forEach(item => {
          column.items.push({
            label: item.textContent.trim(),
            url: item.getAttribute('href') || '',
          });
        });
      }
    });

    const contactTitleEl = doc.querySelector('[data-attribute="title-column-contact"]');
    if (contactTitleEl) {
      result.contactTitle = contactTitleEl.textContent.trim() || result.contactTitle;
    }
    doc.querySelectorAll('[data-attribute="contact-item"]').forEach(item => {
      const labelEl = item.querySelector('[data-attribute="contact-label"]');
      const linkEl = item.querySelector('[data-attribute="contact-link"]');
      result.contactItems.push({
        label: labelEl ? labelEl.textContent.trim() : '',
        text: linkEl ? linkEl.textContent.trim() : '',
        url: linkEl ? linkEl.getAttribute('href') || '' : '',
      });
    });

    const copyrightEl = doc.querySelector('[data-attribute="copyright"]');
    if (copyrightEl) {
      result.copyright = copyrightEl.textContent.trim();
    }

    return result;
  },
};
